/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'MES VIDÉOS COURTES',
    see_more: 'VOIR PLUS',
    no_shorts_found: 'Aucune vidéo courte trouvée',
    shorts: 'Courtes vidéos',
    general_information: 'Informations générales',
    gamification: 'Gamification',
    click_to_select_files: 'Cliquez pour sélectionner des fichiers',
    selected_files: 'Fichiers sélectionnés',
    uploaded: 'Téléversé',
    failed: 'Échec',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'Le système analysera automatiquement et sélectionnera les documents les plus pertinents de la bibliothèque de votre organisation en fonction du contenu requis.',
    select_from_library: ' Sélectionner depuis la bibliothèque',
    search_document: 'Rechercher des documents...',
    selected: 'Sélectionné',
    loading_documents: 'Chargement des documents...',
    review_generated_content: 'Vérifier le contenu généré',
    confirm_and_replace_content: 'Confirmer et remplacer le contenu',
    the_generate_content_will_replace:
      'Le contenu généré remplacera le texte existant sur les pages sélectionnées. Si vous ne souhaitez pas appliquer ces modifications, vous pouvez revenir à l’étape précédente.',
    pages_to_be_updated: 'Pages à mettre à jour',
    generated_revisions: 'Révisions générées',
    lesson_preview: 'Aperçu de la leçon',
    create_new_folder: 'Créer un nouveau dossier',
    rename_item: 'Renommer l’élément',
    enter_folder_name: 'Entrez le nom du dossier :',
    enter_new_name: 'Entrez le nouveau nom :',
    folder_name: 'Nom du dossier :',
    new_name: 'Nouveau nom',
    move_items: 'Déplacer les éléments',
    copy_items: 'Copier les éléments',
    move_here: 'Déplacer ici',
    copy_here: 'Copier ici',
    select_destination_library_and_folder:
      'Sélectionner la bibliothèque et le dossier de destination :',
    items_selected: 'Éléments sélectionnés',
    version: 'Version',
    modified_by: 'Modifié par',
    size: 'Taille',
    restore: 'Restaurer',
    are_you_sure_you_want_to_restore_this_version:
      'Êtes-vous sûr de vouloir restaurer cette version ?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Cela remplacera la version actuelle par celle sélectionnée.',
    restore_this_version: 'Restaurer cette version',
    restore_not_available: 'Restauration non disponible',
    version_history: 'Historique des versions :',
    by_making_items_public:
      'En rendant les éléments publics, ils seront visibles par tous. Veuillez lire les termes et conditions avant de continuer.',
    the_selected_items_will_be_copied:
      'Les éléments sélectionnés seront copiés dans votre bibliothèque publique et visibles par tous.',
    the_selected_items_will_be_copied_to_org:
      'Les éléments sélectionnés seront copiés dans la bibliothèque de votre organisation et visibles par tous les membres de l’organisation.',
    the_selected_items_will_be_copied_to_your_private:
      'Les éléments sélectionnés seront copiés dans votre bibliothèque privée et visibles uniquement par vous.',
    loading_organization: 'Chargement des utilisateurs de l’organisation...',
    click_download_to_view: 'Cliquez sur Télécharger pour voir',
    archive_file: 'Fichier d’archive',
    no_preview_available: 'Aucune prévisualisation disponible',
    audit_report: 'Rapport d’audit',
    audit_type: 'Type d’action',
    i_agree_to_the_terms_and_conditions: 'J’accepte les termes et conditions.',
    this_file_is_indexed_for_ai: 'Ce fichier est indexé pour l’IA.',
    file_is_not_indexed_for_ai: 'Fichier non indexé pour l’IA.',
    no_users_found: 'Aucun utilisateur trouvé',
    no_users_available: 'Aucun utilisateur disponible',
    add_people: 'Ajouter des personnes',
    people: 'Personnes',
    access_type: 'Type d’accès',
    no_group_found: 'Aucun groupe trouvé',
    add_group: 'Ajouter un groupe',
    groups: 'Groupes',
    users_top: 'Utilisateurs',
    confirm_delete: 'Confirmer la suppression',
    do_you_want_remove: 'Voulez-vous vraiment supprimer',
    form_this_documents_permissions: 'des permissions de ce document ?',
    no_users_found_in_this_group: 'Aucun utilisateur trouvé dans ce groupe',
    add_selected_users: 'Ajouter les utilisateurs sélectionnés',
    choose_users_from_the_list: 'Choisir des utilisateurs dans la liste',
    selected_users: 'Utilisateurs sélectionnés',
    archived: 'Archivé',
    request_approval: 'Demander l’approbation',
    document_in_review: 'Document en révision',
    approve: 'Approuver',
    reject: 'Rejeter',
    comment: 'Commentaire :',
    enter_your_commit: 'Entrez votre commentaire...',
    confirm_cancel: 'Confirmer l’annulation',
    upload_3d_zip: 'Téléverser 3D Zip',
    delete_items: 'Supprimer les éléments',
    video_upload_request: 'Demande de téléversement vidéo',
    reject_video: 'Rejeter la vidéo',
    enter_rejection_reason: 'Entrez la raison du rejet...',
    please_provide_a_reason_for_reejection_this_video:
      'Veuillez fournir une raison pour rejeter cette vidéo :',
    generate_trivia_with_ai: 'Générer un quiz avec l’IA',
    select_category: 'Sélectionner une catégorie :',
    number_of_question: 'Nombre de questions',
    generated_questions: 'Questions générées',
    this_will_clear_all_generate_question:
      'Cela supprimera toutes les questions générées. Continuer ?',
    sure_delete: 'Êtes-vous sûr de vouloir supprimer ?',
    delete_this_question: 'Êtes-vous sûr de vouloir supprimer cette question ?',
    loading_quiz: 'Chargement du quiz...',
    creteing_file: 'Création du fichier',
    opening_desktop_app: 'Ouverture de l’application de bureau',
    this_folder_is_empty: 'Ce dossier est vide',
    select_a_competition: 'Sélectionner une compétition...',
    activity_badges: 'Badges d’activité',
    awarded_every_badges:
      'Attribué tous les 4, 8, 16, 32, 64, 128, 256, 512 connexions',
    learning_badges: 'Badges d’apprentissage',
    awarded_every_courses:
      'Attribué tous les 1, 4, 8, 16, 32, 64, 128 cours terminés',
    test_badges: 'Badges de test',
    awarded_every_passes_tests:
      'Attribué tous les 2, 4, 8, 16, 32, 64, 128, 256 tests réussis',
    assignment_badges: 'Badges de devoir',
    awarded_every_passed_assignments:
      'Attribué tous les 1, 2, 4, 8, 16, 32, 64, 128 devoirs réussis',
    perfectionism_badges: 'Badges de perfectionnisme',
    awarded_every_assignments_with_scrore:
      'Attribué pour chaque test ou devoir avec score 90%+',
    communication_badges: 'Badges de communication',
    awarded_every_topics_or_comments:
      'Attribué tous les 2, 4, 8, 16, 32, 64, 128, 256 sujets ou commentaires',
    certification_badges: 'Badges de certification',
    awarded_every_certificates:
      'Attribué tous les 1, 2, 4, 8, 16, 32, 64, 128 certificats',
    level_name: 'Nom du niveau',
    delete_competition: 'Supprimer la compétition',
    this_week: 'Cette semaine',
    this_year: 'Cette année',
    make_organization: 'Rendre organisation',
    no_results_found: 'Aucun résultat trouvé pour',
    no_items_available: 'Aucun élément disponible',
    help_video: 'Vidéos d’aide',
    select_a_video_from_the_list:
      'Sélectionnez une vidéo dans la liste pour commencer à apprendre'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Déposez le fichier et sélectionnez où le télécharger.',
    duplicate_lessoon: 'La leçon est déjà présente dans le cours',
    skill_rule_title: 'Veuillez saisir le titre du parcours de compétence',
    imageCreatorTitle: "Créateur d'image",
    isTranslated: 'Traduit',
    translationCourseDesc:
      'La traduction de ce cours peut prendre quelques minutes. Merci de votre patience !',
    translateCourseTip:
      "Créez un cours traduit que vous pouvez modifier indépendamment de l'original, incluant toutes les leçons et pages.",
    translateModalBtn: 'Traduire',
    translationSuccess: 'Le cours "<0/>" a été traduit avec succès !',
    translatingCourse: 'Traduction du cours en cours...',
    translateModalTitle: 'Traduire le cours',
    translateSelectLang: 'Sélectionnez la langue',
    fileDeleteconfirm:
      'Êtes-vous sûr de vouloir supprimer ce fichier ? Cette action est irréversible.',
    fileDeleteMessage: 'Fichier supprimé avec succès.',
    fileDeleteFailedMessage: 'Échec de la suppression du fichier !',
    fileDelete: 'Supprimer ce fichier.',
    certificate_save_btn: 'Ajouter le certificat à ',
    maze_path_info: "Il n'y a aucun chemin disponible pour le graphe !",
    file_size_mb: 'La taille du fichier doit être inférieure à 25 Mo !',
    reports: {
      products: 'Produits',
      users: 'Utilisateurs',
      ph_username: "Rechercher un utilisateur par nom d'utilisateur",
      ph_id: "Rechercher un utilisateur par numéro d'ID",
      ph_email: 'Rechercher un utilisateur par email'
    },
    select_upload_section_id: 'La section de fichier est obligatoire',
    tags_all: 'Tous',
    delete_file_confirm: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
    delete_file_title: 'Supprimer le fichier',
    tooltip_publish: "Publier le cours selon l'option sélectionnée",
    tooltip_save: 'Enregistrer les mises à jour actuelles du cours',
    tooltip_next: 'Passer au paramètre de cours suivant',
    tooltip_finish: 'Terminer et enregistrer les mises à jour actuelles',
    stories_modal: {
      title_upload: 'Télécharger des histoires',
      title_update: 'Mettre à jour des histoires',
      title_audio: "Fichier audio de l'histoire",
      btn_upload: 'Télécharger',
      btn_update: 'Mettre à jour',
      btn_close: 'Fermer',
      btn_cancel: 'Annuler',
      lbl_cover: "Image de couverture de l'histoire",
      rule_cover: "Veuillez télécharger la couverture audio de l'histoire !",
      lbl_title: "Titre audio de l'histoire",
      rule_title: "Veuillez saisir le titre audio de l'histoire !",
      lbl_description: "Description audio de l'histoire",
      rule_description: "Veuillez saisir la description audio de l'histoire !",
      lbl_file: "Télécharger le fichier audio de l'histoire",
      rule_file: "Veuillez télécharger le fichier audio de l'histoire !",
      rule_file_type:
        "Veuillez télécharger un fichier audio valide pour l'histoire !",
      lbl_select_file: "Sélectionner le fichier audio de l'histoire",
      msg_valid_file:
        "Veuillez sélectionner un fichier audio valide pour l'histoire !",
      msg_success: "Fichier audio de l'histoire téléchargé avec succès",
      msg_failed: "Échec de l'assignation des données média !",
      msg_error: 'Erreur lors du téléchargement du fichier !'
    },
    audio_modal: {
      title_upload: 'Télécharger',
      title_update: 'Mettre à jour',
      title_audio: 'Fichier audio',
      btn_upload: 'Télécharger',
      btn_update: 'Mettre à jour',
      btn_close: 'Fermer',
      btn_cancel: 'Annuler',
      lbl_cover: 'Couverture audio',
      rule_cover: 'Veuillez télécharger la couverture audio !',
      lbl_title: 'Titre audio',
      rule_title: 'Veuillez saisir le titre audio !',
      lbl_description: 'Description audio',
      rule_description: 'Veuillez saisir la description audio !',
      lbl_file: 'Télécharger le fichier audio',
      rule_file: 'Veuillez télécharger un fichier audio !',
      rule_file_type: 'Veuillez télécharger un fichier audio valide !',
      lbl_select_file: 'Sélectionner le fichier audio',
      msg_valid_file: 'Veuillez sélectionner un fichier audio valide !',
      msg_success: 'Fichier audio téléchargé avec succès',
      msg_failed: "Échec de l'assignation des données média !",
      msg_error: 'Erreur lors du téléchargement du fichier !'
    },
    info_episode: "Une image de couverture pour l'épisode.",
    btn_delete_episode: 'Supprimer cet épisode de podcast.',
    btn_edit_marketplace: 'Modifier les détails du marché.',
    btn_save_marketplace: 'Enregistrer les modifications actuelles.',
    btn_ai_podcast: 'Créer un épisode de podcast assisté par IA.',
    btn_upload_podcast: 'Télécharger votre propre épisode audio de podcast.',
    attach_file:
      'Téléchargez des fichiers pour partager plus de contenu avec votre audience',
    fileDownload: 'Télécharger ce fichier.',
    singleEpishode: 'Épisode',
    podcast_music: 'podcast, musique & histoires',
    publishHeader: 'Publier Podcasts, Musique & Histoires',
    editHeader: 'Modifier Podcasts, Musique & Histoires',
    createHeader: 'Créer Podcasts, Musique & Histoires',
    marketplaceHeader: 'Détails du marché Podcasts, Musique & Histoires',
    message_marketplace: 'Veuillez compléter le formulaire du marché !',
    create_podcast_live: 'Podcast et musique en direct',
    create_podcast_custom: 'Podcast et musique personnalisés',
    create_podcast_stories: 'Histoire',
    ai_Assisted_podcast_reation: 'Podcast et musique assistés par IA',
    publishTitle:
      'Publiez podcasts, musique & histoires pour une vue publique.',
    customButton: 'Créer personnalisé',
    customTitle: 'Enregistre les modifications apportées au podcast.',
    updateButton: 'Mettre à jour',
    createButton: 'Créer',
    createNewButton: 'Créer nouveau',
    updateTitle:
      'Mettre à jour les détails actuels du podcast, musique & histoires.',
    createTitle: 'Créer un nouveau podcast, musique & histoires',
    createNewTitle:
      'Un nouveau podcast, musique & histoires sera créé avec les nouvelles informations.',
    podcastTitle: 'Liste des épisodes',
    podcastStoryTitle: "Liste des épisodes d'histoires",
    podcastToolTipTitle: 'Liste des épisodes de podcast',
    uploadAudio: 'Télécharger',
    aiAudio: 'Audio IA',
    emptyPodcast:
      'Aucun enregistrement audio de podcast, musique & histoires pour le moment.',
    emptyStoriesPodcast: 'Aucune histoire ajoutée pour le moment.',
    emptyCreatePodcast:
      "Veuillez créer un podcast pour pouvoir ajouter de l'audio.",
    playPodcast: 'Jouer le podcast, musique & histoires sélectionné.',
    pausePodcast:
      'Mettre en pause le podcast, musique & histoires sélectionné.',
    selectPodcast: 'Sélectionner ce podcast, musique & histoires.',
    downloadPodcast: 'Télécharger cet audio.',
    uploadAudioFile: "Télécharger un nouvel audio et remplacer l'audio actuel.",
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cet audio ?',
    roomName: 'Nom du podcast',
    addGuestTitle: 'AJOUTER UN INVITÉ',
    showTime: 'Heure du spectacle',
    startTime: 'Heure de début',
    endTime: 'Heure de fin',
    erorMsgImg: 'Veuillez sélectionner une image valide.',
    failedMsgImg: "Échec du chargement de l'image. Veuillez réessayer !",
    failedMsgUpload: "Échec du téléchargement de l'image de couverture !",
    btnCoverUpload: 'Télécharger la couverture',
    is_private: 'Privé',
    to_attach: 'Joindre un fichier',
    file_attached: 'Fichier(s) joint(s)',
    main_event: 'Événement principal',
    event: 'Événements',
    upload_pdf: 'Télécharger PDF',
    portrait: 'Portrait',
    landscape: 'Paysage',
    import_from_library: 'Importer le texte depuis la bibliothèque média',
    question_answer_ai: 'Question/Réponse IA',
    take_maze: 'PRENDRE MetaMaze',
    training: 'Formation',
    select_transcribe_locale: 'Sélectionnez la langue pour la transcription',
    transcribe_limit: 'Veuillez saisir les minutes de transcription',
    not_complete: 'Les informations du marketplace ne sont pas complètes',
    complete: 'Les informations du marketplace sont complètes',
    not_admin:
      'Privilèges administrateur requis pour publier sur le marketplace',
    no_course:
      'Veuillez saisir un titre et sélectionner une image pour activer le marketplace',
    scorm_not_complete:
      'Veuillez saisir un titre et sélectionner une image pour télécharger le fichier SCORM',
    not_found_maze: 'MetaMaze non trouvé',
    email_require: 'Les emails sont requis',
    poll_required: 'Les données du sondage sont requises',
    alert: 'Alerte !',
    warning: 'Attention !',
    ok: 'OK',
    cancel: 'Annuler',
    done: 'Terminé',
    insert: 'Insérer',
    private: 'Privé',
    public: 'Public',
    no_connection: 'Connexion Internet perdue',
    switch: 'Basculer',
    share_screen: 'Partager l’écran',
    stop_share_screen: 'Arrêter le partage d’écran',
    share_screen_with_camera: 'Partager l’écran avec la caméra',
    stop_share_screen_with_camera: 'Arrêter le partage d’écran avec la caméra',
    camera_on: 'Caméra activée',
    camera_off: 'Caméra désactivée',
    mic_on: 'Activer le micro',
    mic_off: 'Couper le micro',
    fullscreen: 'Plein écran',
    live_now: 'En direct',
    schedule_on: 'Programmer pour',
    organisations: 'Organisations',
    org_groups: 'Groupes d’organisations',
    specific_user: 'Utilisateur spécifique',
    gif: 'GIF',
    unavailable: 'Indisponible',
    yes: 'Oui',
    no: 'Non',
    event_duration_message: 'Maximum 300 minutes (5 heures)',
    send_email: 'Envoyer une notification par e-mail',
    admin_only: 'Réservé aux administrateurs',
    join: 'Rejoindre',
    leave: 'Quitter',
    share: 'Partager',
    share_text:
      'Veuillez taper l’adresse e-mail de la personne avec qui vous souhaitez partager ce fichier.',
    share_text_title: 'Partager PDF',
    share_text_title_txt: 'Partager le texte',
    select_users: 'Sélectionner les utilisateurs',
    delete: 'Supprimer',
    attachment_event: 'Pièces jointes pour l’événement :',
    transcribe_limit: 'Minutes de transcription',
    monthly_transcribe: 'Limite mensuelle de transcription :',
    enable_ai: 'Activer l’IA :',
    enable_maze: 'Activer MetaMaze :',
    media_service: 'Service média',
    allow_others: 'Autoriser les autres à modifier',
    join_breakout_room: 'Rejoindre la salle de sous-groupes',
    bio: 'Bio',
    linkedin: 'LinkedIn',
    select_org_report:
      'Veuillez trouver et choisir une organisation pour générer le rapport.',
    org_image_not_found: 'Image introuvable',
    insert_text: 'Insérer du texte',
    insert_question_answer: 'Question/Réponse IA',
    modal_title2: 'Galerie de texte',
    my_text_library: 'Ma bibliothèque de textes',
    ai: 'IA',
    public_text_library: 'Bibliothèque de textes publique',
    organization_text_library: 'Bibliothèque de textes de l’organisation',
    no_transcribed_text: 'Aucun texte transcrit trouvé',
    public_text_not_found: 'Texte public transcrit non trouvé',
    org_text_not_found: 'Texte transcrit de l’organisation non trouvé',
    org_video_not_found: 'Vidéo non trouvée',
    canva: 'Faites-le depuis Canva',
    canva_open: 'Cliquez ici pour ouvrir l’éditeur Canva.',
    pdf: 'PDF',
    txt: 'TEXTE',
    human: 'Premium',
    shared_file: 'Votre fichier a été partagé avec succès.',
    error_shared_file:
      'Un problème est survenu lors du partage du fichier. Veuillez réessayer.',
    publish: 'Publier',
    maze_scenes: 'Scènes MetaMaze',
    pexel_images: 'Images Pexel',
    group: 'Groupe',
    group_name: 'Nom du groupe',
    select_group: 'Sélectionner un groupe',
    search_maze: 'Rechercher MetaMaze',
    hosts: 'Hôtes',
    avg_score: 'Score en pourcentage',
    maze_report: 'Rapport MetaMaze',
    maze_view: 'Vue MetaMaze',
    title_maze: 'MetaMaze',
    author: 'Auteur',
    match: 'Correspondance de chemin',
    preview_mazeTitle: 'Titre : ',
    other: 'Autre',
    total: 'TOTAL',
    report_course: 'COURS',
    report_courses: 'COURS',
    report_event: 'ÉVÉNEMENT',
    report_events: 'ÉVÉNEMENTS',
    report_maze: 'MAZE',
    report_personalize_learning: 'APPRENTISSAGE PERSONNALISÉ',
    report_live_assessment: 'ÉVALUATION EN DIRECT',
    report_live_assessments: 'ÉVALUATIONS EN DIRECT',
    report_skill_journey: 'PARCOURS DE COMPÉTENCE',
    skill_journey: 'Parcours de compétence',
    skill_journeys: 'Parcours de compétences',
    date: 'DATE : ',
    search_people: 'Rechercher des personnes',
    passed: 'RÉUSSI',
    failed: 'ÉCHOUÉ',
    item: 'ÉLÉMENT',
    type: 'TYPE',
    minimum_pass_score: 'SCORE MINIMAL POUR RÉUSSIR',
    resources_count: 'NOMBRE DE RESSOURCES',
    back: 'RETOUR',
    resources: 'RESSOURCES',
    time_spent: 'TEMPS PASSÉ (MINUTES)',
    detail: 'DÉTAIL',
    watched_time_mins: 'TEMPS REGARDÉ (MINUTES)',
    personalize_learning: 'Apprentissage personnalisé',
    result: 'Résultat',
    assessment_title: 'Titre',
    marketPlace_graph: 'Graphique du Marché',
    attachments: 'Pièces jointes supplémentaires',
    new_scorm_course: 'Téléverser un nouveau cours SCORM',
    upload_scorm_course: 'Téléverser un cours SCORM',
    new_maze: 'Créer un nouveau MetaMaze',
    new_skill_journey: 'Créer un parcours de compétence',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Parcours de compétence',
    new_discussion_room: 'Créer un nouveau podcast',
    title: 'Que voulez-vous faire aujourd’hui ?',
    build_course: 'Créer mon cours',
    live_broadcast: 'Diffusion en direct',
    invite_users: 'Inviter des utilisateurs dans mon organisation',
    build_voice_over: 'Créer ma voix off',
    view_reports: 'Voir les rapports',
    upload_media: 'Téléverser mes médias ou travaux et les partager',
    main_menu: 'Menu principal',
    get_started: 'COMMENCER',
    search_group: 'Rechercher un groupe d’organisation',
    ai_course: 'Cours IA',
    search_user: 'Rechercher le nom de l’entreprise',
    no_maze: 'Il n’y a actuellement aucun MetaMaze.',
    conference_event_title: 'Événements Conférence',
    conference_event_subTitle: 'Événements Conférence terminés',
    conference_event: 'Il n’y a actuellement aucun événement conférence.',
    no_skill: 'Il n’y a actuellement aucun parcours de compétence.',
    no_podcast: 'Il n’y a actuellement aucun podcast.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Évaluations en direct passées',
    no_live_assessment: 'Il n’y a actuellement aucune évaluation en direct.',
    enrolled_courses: 'Cours',
    my_video_channel: 'Mes chaînes vidéo',
    enrolled_liveEvents: 'Événements en direct',
    sharebot: 'Sharebot',
    selected_language: 'Langue sélectionnée',
    shareSphere_game: 'Jeu ShareSphere',
    maze: 'MetaMaze',
    skill: 'Parcours de compétence',
    channel: 'Chaîne',
    order: 'Commande',
    is_record: 'Enregistrement',
    no_maze_found: 'Aucun MetaMaze trouvé.',
    maze_self_limit_reached: 'Limite d’auto-évaluation MetaMaze atteinte.',
    metamaze_two_times: 'Vous avez déjà effectué ce MetaMaze 2 fois.',
    metamaze_two_times_no_result:
      'Vous avez déjà effectué ce MetaMaze 2 fois. Votre résultat ne sera pas suivi après la deuxième tentative.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Score minimum pour réussir',
    organization: 'Veuillez sélectionner une organisation',
    pass_score_mark: 'Veuillez saisir une note entre 1 et 100',
    maze_cloning_success: 'MetaMaze "<0/>" a été cloné avec succès !',
    create_certificate: 'Créer un certificat',
    create_badge: 'Créer un badge',
    certificate_added: 'Certificat ajouté.',
    badge_added: 'Badge ajouté.',
    certificate_warning:
      'Vous ne pouvez pas modifier le certificat/badge une fois publié !',
    created_course_plan:
      'Modifiez et publiez votre cours créé et planifiez des événements en direct',
    market_place_space: 'Place de marché',
    select_course_language: 'Sélectionner la langue (optionnel)',
    select_language: 'Sélectionner la langue',
    file_upload: 'Téléversement de fichier',
    text: 'Écrire un texte ici…',
    attempts_count: 'Nombre de tentatives autorisées',
    no_of_people_placeholder: 'Nombre de personnes',
    back_to_maze: 'Retour au scénario MetaMaze',
    edit_maze: 'Modifier le Maze',
    wait: 'Veuillez patienter...',
    retry: 'Réessayer',
    publish_scorm_course: 'Publier votre cours SCORM',
    publish_maze: 'Publier votre MetaMaze',
    import: 'Importer des éléments',
    answer_correct: 'Choisissez la bonne réponse',
    author_name: `Entrez le nom de l'auteur`,
    select_category: 'Sélectionnez une catégorie',
    course_outline: 'Ajoutez le plan du cours',
    course_obj: 'Ajoutez les objectifs du cours',
    course_description: 'Ajoutez la description du cours',
    maze_outline: 'Ajoutez le plan du labyrinthe',
    maze_obj: 'Ajoutez les objectifs du labyrinthe',
    maze_description: 'Ajoutez la description du labyrinthe',
    lessons: 'Ajoutez le nombre de leçons',
    user_email_require: `Email de l'utilisateur requis`,
    team_size: `Ajoutez la taille de l'équipe`,
    enter_price: 'Entrez le prix (minimum 5)',
    input_title_maze: 'Entrez le titre du labyrinthe',
    trainer_bio: 'Ajoutez la bio du formateur',
    trainer_linkedin: 'Ajoutez le LinkedIn du formateur',
    error_video: 'Ajoutez le nombre de vidéos',
    input_video_link: 'Ajoutez le lien vidéo',
    number_of_video: 'Nombre de vidéos',
    number_of_lessions: 'Nombre de leçons',
    no_of_people_in_conference: 'Nombre de personnes dans la conférence ?',
    transcribe_settings: 'Paramètres de transcription',
    transcribe: 'Transcrire',
    cloning_maze: 'Clonage de MetaMaze en cours...',
    id_number: 'Numéro d’identification',
    timezone: 'Fuseau horaire',
    edit_maze: 'Modifier',
    delete_maze: 'Supprimer',
    view_maze: 'Voir',
    create_metamaze: 'Créer un nouveau MetaMaze',
    metamaze_scenario: 'Scénario MetaMaze',
    publish_metamaze: 'Paramètres de publication',
    search_result: 'Résultats de recherche :',
    search_for: 'Rechercher',
    search_no_result: '- Aucun résultat !',
    channel_no_available: 'Chaîne non disponible !',
    this_card: 'Ceci est une carte',
    course_no_available: 'Cours non disponible !',
    exit_fullscreen: 'Quitter le mode plein écran',
    bg_image: 'Image de fond',
    introduction: 'Introduction',
    summary: 'Résumé',
    generate_introduction: 'Générer une introduction',
    generate_summary: 'Générer un résumé',
    bullet_points: 'Points clés',
    title_simulation: 'Entrez le titre de la simulation',
    view_generated_images: 'Voir les images générées',
    image_transparency: "Transparence de l'image",
    template_bg_color: 'Couleur de fond du modèle',
    select_template_layout: 'Sélectionnez la mise en page du modèle',
    reload_template: '(Recharger les modèles)',
    are_you_sure_want_close: 'Êtes-vous sûr de vouloir fermer ?',
    all_your_changes_will_be_lost: 'Toutes vos modifications seront perdues.',
    please_checked_before_generated_video:
      'Veuillez vérifier avant de générer la vidéo',
    voice_must_be_selected: 'Une voix doit être sélectionnée',
    avatar_must_be_selected: 'Un avatar doit être sélectionné',
    maximum_five_slides_try_again:
      "Erreur lors de l'extraction des images du fichier. Le fichier ne doit contenir que 5 diapositives au maximum, chacune avec des notes. Veuillez réessayer.",
    back_to_upload: 'Retour au téléchargement',
    uploading_file_to_server: 'Téléchargement du fichier sur le serveur',
    extracting_images_from_your_file: 'Extraction des images de votre fichier',
    upload_your_ppt_or_drag:
      'Téléchargez votre fichier PowerPoint (.PPTX) ou glissez-le ici',
    maximum_five_slides_error:
      'Le fichier PowerPoint ne doit pas dépasser 5 diapositives, et chaque diapositive doit contenir des notes. Sinon, une erreur se produira.',
    number_of_questions_generated: 'Nombre de questions générées',
    quiz_page_this_cannot_be_done:
      'Êtes-vous sûr de vouloir ajouter un quiz à cette page ? Cette action est irréversible.',
    confirm_selection: 'Confirmer la sélection',
    select_quiz_page: 'Sélectionnez la page du quiz',
    lesson_do_you_want_add_this_quiz:
      'À quel moment de la leçon souhaitez-vous ajouter ce quiz ?',
    beginning_of_lesson: 'Au début de la leçon',
    end_of_lesson: 'À la fin de la leçon',
    currently_active_page: 'Page active actuelle',
    finish: 'Terminer',
    upload_selection_file: 'Télécharger le fichier de sélection',
    general_quiz: 'Quiz général',
    manage_sequence: 'Gérer la séquence',
    save_sequence: 'Enregistrer la séquence',
    new: 'Nouveau',
    in_progress: 'En cours',
    recommended_course: 'Cours recommandés',
    up_coming: 'À venir',
    past_live: 'Événements en direct passés',
    input_your_channel_name: 'Entrez le nom de votre chaîne',
    organization_place: "Place de marché de l'organisation",
    marketplace_report: 'Rapport du marché',
    story_writing: "Écriture d'histoire",
    Ai_quiz: 'Quiz IA',
    generate_quiz: 'Générer un quiz',
    create_story: 'Créer une histoire',
    change_layout_page: 'Voulez-vous changer la mise en page de cette page ?',
    change_layout_message:
      'Les textes, images, arrière-plan et logo seront conservés, mais le reste du contenu sera supprimé.',
    reviews: 'Avis',
    tab_attachments: 'Pièces jointes',
    zoom_in: 'Zoom avant',
    zoom_out: 'Zoom arrière',
    zoom_reset: 'Réinitialiser le zoom',
    no_attachment: 'Aucune pièce jointe',
    select_upload_simulation: 'Sélectionnez ou téléchargez une simulation',
    quiz_updated_successfully: 'Quiz mis à jour avec succès !',
    quizes: 'Quizzes',
    trivia: 'Trivia',
    closing: 'Fermeture...',
    products: 'Produits',
    ask_questions: 'Posez une question ici...',
    course_information: 'Informations sur le cours',
    course_assistance: 'Assistance au créateur du cours',
    go_back: 'Retour',
    ai_generate_content_progress: 'Création du contenu en cours',
    view_generate_content: 'Voir le contenu généré',
    generate_error: 'Erreur de génération !',
    confirm_creating_course:
      'Voulez-vous vraiment créer un cours avec ce contenu ?',
    generate_content_automatically:
      'Tout le contenu généré sera ajouté automatiquement aux leçons et pages du cours.',
    quiz_created_successfully: 'Quiz créé avec succès !',
    create_quiz: 'Créer un quiz',
    quiz_setting: 'Paramètres du quiz',
    please_fill_quiz_setting:
      '* Veuillez remplir tous les champs dans les paramètres du quiz',
    question_list: 'Liste des questions',
    add_quiz_to_page: 'Ajouter le quiz à la page',
    form_create_question: 'Formulaire de création de question',
    user_information_updated: 'Informations utilisateur mises à jour !',
    your_stripe_activete_to_continue:
      "Le compte Stripe n'est pas actif. Continuez en le connectant ou en l'activant.",
    connect_tripe: 'Connecter Stripe',
    certificate_sent_sucessfully:
      'Certificat envoyé avec succès à votre email.',
    error_try_again: 'Erreur, veuillez réessayer !',
    error_delete_channel: 'Erreur lors de la suppression de la chaîne.',
    error_update_sub: "Erreur lors de la mise à jour de l'abonnement.",
    end_time_cannot_start:
      "L'heure de fin ne peut pas être antérieure à l'heure de début.",
    start_date_time_interval: 'Date et heure de début requises !',
    podcast_updated_successful: 'Podcast mis à jour avec succès.',
    podcast_created_successful: 'Podcast créé avec succès.',
    podcast_published_successful: 'Podcast publié avec succès.',
    podcast_cover_updated: 'Image de couverture du podcast mise à jour.',
    new_podcast_details:
      'Créer un nouveau podcast avec le podcast actuel et de nouveaux détails.',
    current_update_podcast:
      'Mettre à jour le podcast actuel avec musique et histoire.',
    create_new_podcast: 'Créer un nouveau podcast',
    publish_podcast_public_view: 'Publier le podcast au public',
    only_allowed_twenty_five_email: 'Maximum 25 adresses e-mail autorisées',
    only_allowed_five_email: 'Maximum 5 adresses e-mail autorisées',
    cover_is_required: 'La couverture est requise',
    topic_is_required: 'Le sujet est requis',
    delete_schedule: 'Supprimer le planning',
    make_as_coaching: 'Marquer comme coaching',
    manage_category: 'Gérer la catégorie',
    threshold: 'Seuil',
    threshold_popup:
      'Seuil (en pourcentage) à partir duquel commencer les recommandations pour cette catégorie',
    list_of_catagory: 'Catégories',
    category_name: 'Nom de la catégorie',
    category_threshold: 'Seuil de la catégorie',
    play_game: 'Jouer au jeu',
    switching_organization: "Changement d'organisation...",
    coaching_session: 'Session de coaching',
    required_channel_id: "L'ID du canal est requis !",
    error_occured_try_again: "Une erreur s'est produite. Réessayez !",
    please_complete_marketplace_form:
      'Veuillez compléter le formulaire du marché !',
    upload_file_corrupt: 'Le fichier téléchargé est corrompu.',
    course_not_published: 'Le cours n’est pas encore publié !',
    error_request: 'Erreur dans la requête. Veuillez réessayer !',
    skill_request: 'Veuillez compléter les champs manquants !',
    error_occured: "Une erreur s'est produite. Réessayez !",
    show_time: "Heure d'affichage",
    start_time: 'Heure de début',
    end_time: 'Heure de fin',
    room_name: 'Nom du podcast',
    add_guest_speaker: 'Ajouter un intervenant invité',
    cover_picture: 'Image de couverture',
    guest_speaker: 'Intervenants invités',
    see_more: 'Voir plus',
    see_less: 'Voir moins',
    background: 'Arrière-plan',
    icon: 'Icône',
    icon_size: "Taille de l'icône",
    icon_color: "Couleur de l'icône",
    only_text: 'Texte',
    change_bg: "Changer la couleur d'arrière-plan",
    bg_color: "Couleur d'arrière-plan",
    font_size: 'Taille de la police',
    normal: 'Normal',
    change_color: 'Changer la couleur du texte',
    slant_text: 'Texte en italique',
    text_radius: 'Rayon du texte',
    vertical_align: 'Alignement vertical',
    horizontal_align: 'Alignement horizontal',
    change_icon_color: "Changer la couleur de l'icône",
    upload_icon: 'Télécharger une icône',
    upload_signature: 'Télécharger une signature',
    add_another_sign: 'Ajouter une autre signature',
    name_badges: 'Nom des badges',
    should_less_150: 'doit contenir 150 caractères ou moins',
    your_badge: 'Votre badge',
    do_you_want_delete_badge: 'Êtes-vous sûr de vouloir supprimer ce badge ?',
    do_you_want_delete_cert:
      'Êtes-vous sûr de vouloir supprimer ce certificat ?',
    upload_logo: 'Télécharger le logo',
    name_of_cert: 'Nom du certificat',
    upload_cert: 'Mettre à jour le certificat',
    your_cert: 'Votre certificat',
    translate_to: 'Traduire en',
    select_file_attach: 'Sélectionner un fichier à joindre',
    certificate: 'Certificat',
    badge: 'Badge',
    publish_options: 'Options de publication',
    publish_skills_journey: 'Publier le parcours de compétences',
    videos: 'Vidéos',
    generate_ai_video:
      'Le processus de génération de la vidéo peut prendre un certain temps. Vous serez notifié par e-mail une fois terminé.',
    trainer_information: 'Informations sur le formateur',
    promotional_video_link: 'Lien de la vidéo promotionnelle',
    please_select: 'Veuillez sélectionner',
    image_name: "Nom de l'image :",
    image_size: "Taille de l'image :",
    charecters_fifteen_less: '15 caractères ou moins',
    leadership: 'Leadership',
    text_arc: 'Arc de texte',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    badge_history: 'Historique des badges',
    templates: 'Modèles',
    sign: 'Signature',
    logo: 'Logo',
    certificate_history: 'Historique des certificats',
    please_wait: 'Veuillez patienter...',
    information: 'Informations',
    support_five_thousand_live_event:
      "Supporte jusqu'à 5000 participants pour l'événement",
    support_ten_live_event: 'Supporte jusqu’à 10 participants vidéo en direct',
    we_will_back_participant:
      'Nous reviendrons avec un événement pouvant accueillir un grand nombre de participants.',
    course_objectives: 'Objectifs du cours',
    course_outlines: 'Plan du cours',
    price_dollor: 'Prix (USD)',
    not_completed: 'Non terminé',
    enable_marketplace: 'Activer la place de marché',
    enable_course_ai: 'Activer la création de cours IA',
    enable_report_to_admin: "Activer le rapport à l'administrateur",
    enable_white_label: 'Activer le label blanc',
    enable_eleven_labs_for_maze_play: 'Activer Elevenlabs pour Maze Play',
    enable_eleven_labs_for_maze_play_cloned:
      'Activer Elevenlabs pour les voix clonées',
    not_completed: 'Non terminé',
    simulation_quiz: 'Quiz de simulation',
    bg_color_setting: 'Paramètre de couleur de fond',
    color_preview: 'Aperçu de la couleur',
    choose_new_color: 'Choisir une nouvelle couleur',
    remove_color: 'Supprimer la couleur',
    apply_color: 'Appliquer la couleur',
    elemeent_in_a_sceenario_page:
      "Vous ne pouvez pas ajouter d'autres éléments sur la page du défi. Essayez sur d'autres pages ou supprimez l'élément du défi.",
    no_data_found: 'Aucune donnée trouvée',
    references: 'Références',
    open_file: 'Ouvrir le fichier',
    showing_result: 'Affichage des résultats :',
    fiften_day_free_trail: 'Essai gratuit de 15 jours',
    your_browser_does_not_support:
      "Votre navigateur ne prend pas en charge l'audio.",
    podcast_desc: 'Description du podcast',
    input_podcast_desc: 'Saisissez la description du podcast',
    podcast_obj: 'Objectifs du podcast',
    input_podcast_obj: 'Saisissez les objectifs du podcast',
    podcast_outline: 'Plan du podcast',
    input_podcast_outline: 'Saisissez le plan du podcast',
    add_file: 'Ajouter un fichier',
    generate_podcast_audio: 'Générer l’audio du podcast',
    generate_uploaded_file_input_parameter:
      'Génération basée sur le contenu des fichiers téléchargés.',
    go_backe_generation_state: 'Retour à l’état de génération de contenu',
    create_ai_powered_podcast: 'Créer des épisodes de podcast avec IA',
    generate_voice_for_all_podcast: 'Générer la voix pour tous les épisodes',
    create_podcast_episode: 'Créer un épisode de podcast',
    voice_name: 'Nom de la voix',
    input_custom_name: 'Entrez un nom personnalisé !',
    enter_custom_name: 'Entrez le nom personnalisé de la voix',
    upload_complete: 'Téléversement terminé',
    uploading_in_progress: 'Téléversement en cours...',
    podcast_stream_content: 'Contenu de la série de podcast',
    upload_podcast_cover: 'Téléversez la couverture du podcast !',
    enter_podcast_name: 'Entrez le nom du podcast !',
    podcast_topic: 'Sujet du podcast',
    enter_podcast_topic: 'Entrez le sujet du podcast !',
    enter_podcast_desc: 'Entrez la description du podcast !',
    number_of_speaker: 'Nombre de locuteurs',
    select_the_number_of_speaker: 'Sélectionnez le nombre de locuteurs !',
    number_of_episode: 'Nombre d’épisodes',
    input_number_of_episode: 'Entrez le nombre d’épisodes !',
    podcast_length: 'Durée du podcast',
    select_the_podcast_length: 'Sélectionnez la durée du podcast !',
    short_podcast: 'Court (5-10 minutes)',
    medium_podcast: 'Moyen (15-18 minutes)',
    long_podcast: 'Long (18 minutes ou plus)',
    name_of_host: "Nom de l'hôte",
    enter_host_name: "Entrez le nom de l'hôte !",
    guest_name: 'Noms des invités',
    enter_guest_name: 'Entrez les noms des invités !',
    choose_speaker_tone: 'Choisissez le ton du locuteur',
    enter_speaker_tone: 'Choisissez le ton de la voix du podcast !',
    informal: 'Informel',
    formal: 'Formel',
    serious: 'Sérieux',
    light_humor: 'Humour léger',
    casual: 'Décontracté',
    select_content_source: 'Sélectionnez la source du contenu',
    from_internet: 'Depuis Internet',
    upload_pdf_internet: 'Téléversez un PDF ou une page de contenu',
    note: 'Remarque :',
    podcast_content_will_be_automatically_generated:
      'Le contenu du podcast sera généré automatiquement à partir de sources internet fiables.',
    upload_or_select_file: 'Téléversez ou sélectionnez un fichier !',
    podcast_eposode_title: "Titre de l'épisode du podcast",
    enter_podcast_title: "Entrez le titre de l'épisode !",
    podcast_episode_des: "Description de l'épisode du podcast",
    enter_podcast_episode_des: "Entrez la description de l'épisode !",
    voice: 'Voix',
    music: 'Musique',
    select_music: 'Choisissez la musique',
    play_the_music: 'Jouer la musique',
    stop_the_music: 'Arrêter la musique',
    context: 'Contenu',
    generate_audio_content_selected_voice:
      'Générer l’audio avec la voix sélectionnée.',
    required_field_before_submitting:
      'Veuillez remplir tous les champs obligatoires avant de soumettre.',
    regenerate_voice: 'Régénérer la voix',
    generate_voice: 'Générer la voix',
    your_browser_does_not_suppot:
      "Votre navigateur ne prend pas en charge l'audio.",
    are_sure_leave_podcast: 'Êtes-vous sûr de vouloir quitter le podcast ?',
    broadcast_ongoing:
      'La diffusion est en cours. Voulez-vous vraiment quitter cette page ?',
    brodcaster_unavailable: 'Le diffuseur n’est pas disponible.',
    setting_calender_for_booking: 'Réserver le calendrier',
    add_calender: 'Ajouter un calendrier',
    waiting_join_host: "En attente de l'arrivée de l'hôte...",
    no_reviews_found: 'Aucun avis trouvé',
    rated_already: 'Vous avez déjà noté ce live',
    downlink_png: 'Télécharger en PNG',
    downlink_jpg: 'Télécharger en JPG',
    donwload_file_format: 'Choisissez le format du fichier à télécharger.',
    crashed_event:
      "L'événement a été interrompu. Il est nécessaire de créer un nouvel événement. Nous nous excusons pour le désagrément.",
    prompt: 'Invite :',
    generated_image: '🚀 Création d’image en cours... Veuillez patienter.',
    download_add: 'Télécharger tout',
    setting_generator: 'Paramètres du générateur',
    enter_image_prompt: "Entrez le sujet de l'image",
    image_prompt: "Sujet de l'image",
    negative_prompt: 'Contenu indésirable',
    negative_image_prompt: 'Sujet d’image indésirable',
    number_output: 'Nombre d’images à générer',
    enter_number_output: 'Entrez le nombre d’images à générer',
    image_style: "Style de l'image",
    output_format: 'Format de sortie',
    seeds: 'Graines',
    enter_seeds: 'Entrez les graines',
    performance_mode: 'Mode performance',
    quality: 'Qualité',
    speed: 'Vitesse',
    balanced: 'Équilibré',
    guidance_scale: 'Échelle de guidage',
    enter_guidance: 'Entrez l’échelle de guidage',
    select_image: 'Sélectionnez une image.',
    image_prmt: "Sujet de l'image",
    generate_image_list_empty: 'Les images générées ne sont pas disponibles.',
    knowledge_center_tooltrip_des:
      'Obtenez des réponses précises et pertinentes basées sur des informations collectées sur internet. Le modèle IA est basé sur des textes internet téléchargés.',
    contexts: 'Contextes',
    ai_processing_video_sharebot:
      'Le traitement IA des vidéos Sharebot est valable uniquement 24 heures.',
    remove_sharebot_video: `Pour supprimer la vidéo représentative Sharebot, supprimez l'extrait audio et la vidéo.`,
    remove_sharebot_video_audio:
      "La suppression de l'extrait audio supprime le lien Sharebot de la vidéo/audio, mais la vidéo reste dans la médiathèque/la chaîne.",
    monthly_live_stream:
      'Contactez-nous pour modifier les limites mensuelles de diffusion en direct.',
    monthly_transcribe_limit:
      'Contactez-nous pour modifier les limites mensuelles de transcription vocale.',
    must_be_one_to_three_hundred:
      'La valeur doit être comprise entre 1 et 300 minutes.',
    all_field_required: 'Tous les champs sont obligatoires.',
    duration_minute: 'Durée (max 300 minutes)',
    gender: 'Genre',
    select_gender: 'Sélectionner le genre',
    accent: 'Accent',
    select_accent: 'Sélectionner l’accent',
    create_voice: 'Créer une voix',
    enter_voice_name: 'Entrez le nom de la voix',
    select_voice_gender: 'Sélectionner le genre de la voix',
    upload_voice: 'Téléverser votre voix',
    upload_voice_mp_three: 'Téléverser votre voix (.mp3)',
    cloned_voice: 'Voix clonée',
    voice_type: 'Type de voix',
    select_voice_type: 'Sélectionner le type de voix',
    sharelook_stand: 'Standard',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Personnalisée (voix clonée)',
    create_auto_flow: 'Créer un flux automatique',
    how_many_layers: 'Combien de niveaux',
    verify_selection: 'Vérifier la sélection',
    uploaded_successful: 'Téléversement réussi',
    upload_failed: 'Échec du téléversement',
    upload_only_five_mb: 'Téléverser des fichiers (PDF, max 5 fichiers)',
    docs_from_org_library: 'Documents de la bibliothèque de l’organisation',
    failed_maze_generate:
      'Échec de la génération du labyrinthe. Veuillez réessayer.',
    generate_metamaze: 'Génération de MetaMaze...',
    metamaze_being_generated:
      'MetaMaze est en cours de génération. Vous recevrez un e-mail une fois terminé.',
    metamaze_generate_successfully: 'MetaMaze généré avec succès !',
    metamaze_with_proceed: 'Vous pouvez maintenant continuer avec MetaMaze.',
    ai_metamaze_generate: 'MetaMaze généré par l’IA',
    what_kind_maze_create: 'Quel type de labyrinthe souhaitez-vous créer ?',
    manual_metamaze_creation: 'Création manuelle de MetaMaze',
    manually_maze_customizing_scnario:
      'Personnalisez les scénarios et les choix manuellement',
    maze_ai_generated: 'Labyrinthe généré automatiquement par IA',
    unmark_deadend: 'Désélectionner une impasse',
    mark_deadend: 'Marquer comme impasse',
    select_multiple_image_for_scenario:
      'Sélectionnez plusieurs images pour ce scénario.',
    select_your_image: 'Votre image sélectionnée',
    click_to_preview: 'Cliquez pour prévisualiser',
    are_you_sure_delete_image:
      'Êtes-vous sûr de vouloir supprimer cette image ?',
    select_image_from_library: 'Sélectionner une image de la médiathèque',
    uploading_video: 'Téléversement de la vidéo...',
    tree_node_type: 'Type de nœud d’arbre',
    correct_option_scenario: 'Option / scénario correct',
    incorrect_option: 'Option incorrecte',
    option_scenario_without_text: 'Option / scénario sans texte',
    dead_end: 'Impasse (marque rouge)',
    correct_path: 'Chemin correct',
    incorrect_path_not_selected_correct_option_path:
      'Chemin incorrect / option correcte non sélectionnée',
    double_click_on_tree_node:
      'Double-cliquez sur un nœud pour voir son scénario associé.',
    add_scenario: 'Ajouter un scénario',
    add_option: 'Ajouter une option',
    an_error_occured: 'Une erreur est survenue :',
    download_summary: 'Télécharger le résumé',
    step_wise_analysis: 'Analyse étape par étape',
    step: 'Étape',
    upload_csv_file: 'Téléverser un fichier CSV',
    download_template_to_import: 'Télécharger le modèle à importer',
    please_input_email: 'Veuillez saisir un e-mail',
    email_at_least_three_characters:
      'L’e-mail doit contenir au moins 3 caractères',
    email_cannot_be_empty: 'L’e-mail ne peut pas être vide',
    input_email_in_new_line: 'Entrez chaque e-mail sur une nouvelle ligne',
    role: 'Rôle',
    select_role: 'Sélectionner le rôle',
    select_group: 'Sélectionner le groupe',
    identification_number: 'Numéro d’identification (facultatif)',
    add_identification_number: 'Ajouter un numéro d’identification',
    pie_chart_of_all_categories:
      'Diagramme circulaire de toutes les catégories sur Sharelook',
    total_sharesphere_question_answered_by_users:
      'Questions ShareSphere répondues par les utilisateurs avec succès / échec',
    voice_style_over_the_text:
      'Appliquer différents styles de voix au texte écrit. Lorem Ipsum est le texte standard de l’industrie depuis les années 1500.',
    input_your_question: 'Entrez votre question !',
    make_me_sales_manager: 'Ex. - Fais de moi un responsable commercial',
    enter_the_number_relevant_document:
      'Entrez le nombre de documents pertinents',
    please_wait_loading_result:
      'Veuillez patienter, chargement des résultats...',
    no_result_found:
      'Aucun résultat trouvé. Essayez de reformuler votre question.',
    browser_doesnot_support_iframes:
      'Votre navigateur ne supporte pas les iframes',
    total_duration: 'Durée totale',
    number_of_messages: 'Nombre de messages',
    search_result: 'Résultat de la recherche',
    count_result: '(1244 résultats)',
    your_other_interests: 'Vos autres centres d’intérêt',
    your_total_score: 'Votre score total',
    add_a_question: '+ Ajouter une question',
    travia_question_empty: 'Aucune question Trivia disponible',
    video_generation_is_on_queue: 'Votre vidéo est en file d’attente !',
    checking_video_status: 'Vérification du statut de la vidéo...',
    total_quizzes: 'Total des quiz',
    number_of_votes: 'Nombre de votes',
    total_events: 'Total des événements',
    number_of_rates: 'Nombre de notes',
    number_of_likes: 'Nombre de mentions J’aime',
    all_courses: 'Tous les cours',
    total_questions: 'Nombre total de questions',
    no_skill_journey: 'Aucun parcours de compétences disponible !',
    search_no_results: '- Aucun résultat !',
    no_image_generated: 'Aucune image générée pour le moment !',
    all_topic_in_this_lesson:
      'Cela supprimera tous les sujets de cette leçon. Cette action est irréversible.',
    content_has_been_generated: 'Le contenu a déjà été généré pour ce sujet.',
    update_course_template: 'Mettre à jour le modèle de cours',
    add_course_template: 'Ajouter un modèle de cours',
    create_course_now: 'Créer un cours maintenant',
    preview_course: 'Aperçu du cours',
    layout: 'Disposition',
    import_from_youtube: 'Importer depuis YouTube',
    my_media_library: 'Ma médiathèque',
    bg_added: 'Image de fond ajoutée',
    add_bg: 'Ajouter une image de fond',
    booked_schedule: 'Planning réservé',
    add_schedule: 'Ajouter un planning',
    are_you_delete_schedule: 'Êtes-vous sûr de vouloir supprimer ce planning ?',
    add_task: 'Ajouter une tâche',
    update_calender: 'Mettre à jour le calendrier',
    manage_cookies: 'Gérer les cookies',
    cookie_banner_text:
      'Nous utilisons des cookies pour améliorer votre expérience de navigation, analyser le trafic du site Web et personnaliser le contenu. Votre confidentialité est importante pour nous.',
    accept_all_cookies: 'Tout accepter',
    reject_all: 'Tout refuser',
    customize: 'Personnaliser',
    cookie_preferences_title:
      'Préférences de cookies et paramètres de confidentialité',
    privacy_subtitle:
      'Votre confidentialité compte pour nous. Choisissez les cookies avec lesquels vous êtes à l’aise. Vous pouvez modifier ces paramètres à tout moment.',
    save_choices: 'Enregistrer mes choix',
    strictly_necessary: 'Strictement nécessaires',
    strictly_necessary_desc:
      'Ces cookies sont essentiels au bon fonctionnement du site Web. Ils permettent des fonctionnalités de base comme la navigation, la soumission de formulaires et l’accès aux zones sécurisées. Le site Web ne peut pas fonctionner correctement sans eux.',
    analytics_performance: 'Analyse et performance',
    analytics_performance_desc:
      'Ces cookies nous aident à comprendre comment les visiteurs interagissent avec notre site Web en collectant et en rapportant des informations de manière anonyme. Cela nous aide à améliorer les performances et l’expérience utilisateur de notre site.',
    advertising_marketing: 'Publicité et marketing',
    advertising_marketing_desc:
      'Ces cookies sont utilisés pour rendre les messages publicitaires plus pertinents pour vous. Ils empêchent la réapparition continue des mêmes publicités et garantissent leur bonne diffusion pour les annonceurs.',
    tracking_social: 'Suivi et réseaux sociaux',
    tracking_social_desc:
      'Ces cookies permettent des fonctionnalités et une personnalisation avancées, telles que les fonctions de réseaux sociaux et le contenu personnalisé. Ils peuvent être définis par nous ou par des fournisseurs tiers.',
    functional: 'Fonctionnels',
    functional_desc:
      'Ces cookies permettent des fonctionnalités avancées comme l’assistance en ligne, l’aide en direct et d’autres fonctions interactives qui améliorent votre expérience sur notre site Web.',
    your_rights: 'Vos droits :',
    rights_description:
      'Vous pouvez retirer votre consentement à tout moment, accéder à vos données ou en demander la suppression.',
    withdraw_consent: 'Retirer tout consentement',

    how_many_options: 'Combien d’options',
    add_content: 'Ajouter du contenu',
    downloads_center: 'Centre de téléchargements',
    sharelook_help_center: 'Centre d’aide Sharelook',
    channel_outline: 'Aperçu du canal',
    channel_objectives: 'Objectifs du canal',
    no_sop_available: 'Aucune liste de SOP disponible.',
    generate_world_summary: 'Générer un scénario',
    world_scenario: 'Scénario réel',
    drag_icon_hint:
      'Astuce : faites glisser l’icône sur le canevas pour la positionner',
    drag_text_hint:
      'Astuce : faites glisser le texte sur le canevas pour le positionner',
    edit_badge: 'Modifier le badge',
    create_new_badge: 'Nouveau badge',
    select_video_preview: 'Sélectionnez une vidéo à prévisualiser',
    certificate_title_required: 'Le titre du certificat est requis',
    discard_changes: 'Annuler les modifications',
    edit_certificate: 'Modifier le certificat',
    add_another_logo: 'Ajouter un autre logo',
    optional: 'Optionnel',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Créer une nouvelle quête',
    quest_filter_title: 'Quête',
    sharelook_assistance: 'Coaching Sharelook',
    upload_scorm_zip: 'Téléverser un fichier SCORM zip',
    only_letters_numbers_space_dot_allowed:
      'Seules les lettres, chiffres, espaces et points sont autorisés !',
    video_playing: 'Lecture en cours',
    course_price_message: `*Le cours ne sera publié qu’aux utilisateurs de l’organisation et ne peut pas être revendu sur la place de marché.`,
    lesson_must_be_positive: 'Le nombre de leçons doit être supérieur à 1',
    btn_proceed: 'Continuer',
    rule_select_music: 'Veuillez sélectionner une musique',
    course_info: 'Informations sur le cours',
    content_selection: 'Sélection du contenu',
    course_content_source: 'Source du contenu du cours',
    choose_how_to_source:
      'Choisissez comment obtenir le contenu pour ce cours :',
    automatic_selection: 'Sélection automatique',
    system_will_automatically_select_relavant_documents:
      'Le système sélectionnera automatiquement les documents pertinents de votre bibliothèque',
    manual_selection: 'Sélection manuelle',
    choose_specific_documents_from_your_library:
      'Choisissez des documents spécifiques dans votre bibliothèque',
    upload_files: 'Téléverser des fichiers',
    upload_new_documents:
      'Téléverser de nouveaux documents (PDF, DOC, DOCX, PPT, PPTX, TXT) – maximum 5 fichiers',
    file: 'fichier',
    ready_to_upload: 'prêt à téléverser',
    clear_all: 'Tout effacer',
    confirm_course_wide_premiew:
      'Confirmer la prévisualisation du cours complet',
    generate_course_preview: 'Générer un aperçu du cours',
    instructions_across_the_course_to_generate:
      'Nous appliquerons vos instructions à l’ensemble du cours pour générer un aperçu. Vérifiez tout avant de décider de conserver ou d’annuler les modifications.',
    instruction_to_preview_course_wide:
      'Instructions pour prévisualiser le cours complet :',
    edit_content: 'Modifier le contenu',
    manage_course_template: 'Gérer le modèle de cours',
    undo: 'Annuler',
    apply_changes: 'Appliquer les modifications',
    characters: 'caractères',
    apply_all: 'Tout appliquer',
    apply_to_all: 'Appliquer à tous',
    use_this_content: 'Utiliser ce contenu',
    original: 'Original',
    edited: 'Modifié',
    edited_content_preview: 'Aperçu du contenu modifié',
    apply_edits_to_all_topices:
      'Appliquer les modifications à tous les sujets ?',
    current_editing_instructions_across_the_whole_course:
      'Cela appliquera vos instructions actuelles à l’ensemble du cours. Vous pourrez consulter l’aperçu combiné avant d’enregistrer.',
    edit_content_instructions: 'Instructions de modification du contenu',
    generate_content_for_this_topic_instruction:
      'Générer le contenu pour ce sujet selon vos instructions',
    descrip_edit_content:
      'Décrivez comment modifier ce contenu (ex. : raccourcir, simplifier, reformuler)',
    try_short_clear_direcctives: `Essayez des directives courtes et claires. Exemples : « réduire à 100 mots, garder les points clés », « simplifier le langage », « rendre plus concis et supprimer le superflu ».`,
    we_preserve_the_core_meaning:
      'Nous préservons le sens principal tout en appliquant vos instructions.',
    feedback_optional: 'Commentaires (optionnel)',
    write_your_feedback_here: 'Écrivez vos commentaires ici',
    from_web: 'Depuis le web',
    from_desktop: 'Depuis le bureau',
    pleae_wait_processing: 'Veuillez patienter, traitement en cours...',
    create_simulation_from_screen_capture:
      'Créer une simulation à partir d’une capture d’écran',
    sharelook_not_found: 'ShareLook introuvable',
    sharelook_screen_capture_application_not_be_opened:
      'L’application de capture d’écran ShareLook n’a pas pu être ouverte. Elle n’est peut-être pas installée sur votre ordinateur.',
    download_sharelook: 'Télécharger ShareLook',
    launch_sharelook_application: 'Lancer l’application ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Cela ouvrira l’application ShareLook pour la capture d’écran.',
    sharelook_dosenot_open:
      'Si ShareLook ne s’ouvre pas, il n’est peut-être pas installé sur votre ordinateur.',
    open_sharelook: 'Ouvrir ShareLook',
    download_app: 'Télécharger l’application',
    background_image_setting: 'Paramètres de l’image d’arrière-plan',
    current_image: 'Image actuelle',
    change_image: 'Changer l’image',
    remove_image: 'Supprimer l’image',
    no_background_image_selected: 'Aucune image d’arrière-plan sélectionnée',
    add_image: 'Ajouter une image',
    this_will_open_for_screen_recording:
      'Cela ouvrira l’application ShareLook pour l’enregistrement d’écran.',
    ai_image_generation: 'Génération d’images par IA',
    image_edit: 'Édition d’image',
    text_to_image: 'Texte en image',
    output_gallary: 'Galerie de sortie',
    instant_generation: 'Prêt pour une génération instantanée',
    prompt_and_unleash_the_power: 'Entrez votre prompt et libérez sa puissance',
    use_this_image: 'Utiliser cette image',
    error_generating: 'Erreur lors de la génération.',
    generation_tips: 'Astuces de génération',
    detailed_descriptions_for_more_accurate_results:
      'Utilisez des descriptions détaillées pour obtenir des résultats plus précis',
    reference_image: 'Image de référence',
    select_pixel_image: 'Sélectionner une image pixelisée',
    max_mb: 'Max 50 Mo',
    please_enter_text_to_appear_image:
      'Veuillez entrer le texte à afficher dans l’image',
    enter_text_to_apear_in_the_image: 'Entrez le texte à afficher dans l’image',
    generate_image: 'Générer l’image',
    prompt_assistant: 'Assistant de prompt',
    generate_image_using_suggested_prompt:
      'Générer une image à l’aide du prompt suggéré',
    talk_to_ai_about_the_image_generate:
      'Discutez avec l’IA de l’image que vous souhaitez générer',
    ask_for_prompt_suggestions: 'Demander des suggestions de prompt...',
    enter_a_search_term_to_find_stock_images:
      'Entrez un terme de recherche pour trouver des images libres de droits',
    choose_your_content_source: 'Choisissez votre source de contenu :',
    upload_new_document_from_your_device:
      'Téléversez de nouveaux documents depuis votre appareil',
    automatic_library_selection: 'Sélection automatique de la bibliothèque',
    system_automatically_selects_relevant_document:
      'Le système sélectionne automatiquement les documents pertinents',
    manual_library_selection: 'Sélection manuelle de la bibliothèque',
    generate_content: 'Générer le contenu',
    add_to_current_page: 'Ajouter à la page actuelle',
    generate_bullet_points: 'Générer des points clés',
    generating: 'Génération en cours',
    this_may_take_a_few_moments: 'Cela peut prendre quelques instants',
    apply_to_page: 'Appliquer à la page',
    scenario_escription: 'Description du scénario :',
    feedback: 'Retour',
    form_mode: 'Mode Formulaire',
    chat_mode: 'Mode Chat',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Cela générera une continuation de l’histoire sélectionnée en utilisant l’IA.',
    continue_this_story_question: 'Continuer cette histoire ?',
    continue_this_story: 'Continuer cette histoire',
    what_will_happen: 'Que va-t-il se passer :',
    the_ai_will_analyze_the_existing_story_content:
      "L'IA analysera le contenu existant de l'histoire",
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Générer une continuation naturelle qui suit le même ton et style',
    create_new_content_that_build_upon_the_current_narrative:
      'Créer un nouveau contenu qui s’appuie sur le récit actuel',
    this_process_may_take_a_few_moments_to_complete:
      'Ce processus peut prendre quelques instants.',
    no_existing_stories_found_for_this_course:
      'Aucune histoire existante trouvée pour ce cours.',
    create_your_first_story: 'Créez votre première histoire',
    existing_stories: 'Histoires existantes',
    create_new_story: 'Créer une nouvelle histoire',
    tone: 'Ton',
    style: 'Style',
    genre: 'Genre',
    loading_your_stories: 'Chargement de vos histoires...',
    edit_story: 'Modifier l’histoire',
    story_preferences: 'Préférences de l’histoire',
    please_input_your: 'Veuillez saisir votre',
    add_character_names_and_press_enter:
      'Ajouter les noms des personnages et appuyer sur Entrée',
    select_or_type_your: 'Sélectionnez ou tapez votre',
    enter_your: 'Entrez votre',
    position_of_the_story_in_the_lesson:
      "La position de l'histoire dans la leçon. L'histoire sera ajoutée comme bloc à la position spécifiée.",
    save_previous_content_on_the_pages:
      'Sauvegarder le contenu précédent sur les pages',
    the_existing_content_in_the_selected_pages:
      "Le contenu existant des pages sélectionnées sera remplacé par l'histoire générée.",
    real_world_scenario: 'Scénario réel',
    add_optional_instructions:
      'Ajouter des instructions optionnelles (ton, longueur, public, etc.)',
    ready_to_enerate_your_real_world_scenario:
      'Prêt à générer votre scénario réel',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Cliquez sur "Générer un scénario réel" pour créer un scénario réaliste basé sur le contenu de votre leçon.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      "L'IA analysera le sujet et le contenu de votre leçon",
    generate_a_practical_real_world_scenario:
      'Générer un scénario réel pratique',
    you_can_then_edit_and_customize_the_result:
      'Vous pouvez ensuite éditer et personnaliser le résultat',
    add_it_as_a_new_page_to_your_lesson:
      'Ajouter comme nouvelle page à votre leçon',
    regenerate_with_instructions: 'Régénérer avec instructions',
    add_real_world_scenario: 'Ajouter un scénario réel',
    generate_real_world_scenario: 'Générer un scénario réel',
    simulation_has_been_stopped: 'La simulation a été arrêtée !',
    loading_simulation: 'Chargement de la simulation...',
    you_have_exhausted_all_the_attempts:
      'Vous avez épuisé toutes les tentatives',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Étudiez le scénario sur cette page et sélectionnez la bonne réponse parmi les options ci-dessous.',
    attempts_limit_reached:
      'Limite de tentatives atteinte. Vous pouvez rejouer, mais votre score ne sera pas enregistré.',
    play_again: 'Rejouer',
    import_music_from_computer: 'Importer de la musique depuis l’ordinateur.',
    more: 'plus',
    no_badge_yet: 'Aucun badge pour le moment',
    competition_filter: 'Filtre de compétition',
    global_leaderboard: 'Classement mondial',
    placeholder_for_the_global_leaderboard:
      'Ceci est un espace réservé pour le classement mondial.',
    badge_editor: 'Éditeur de badges',
    adjust_the_appearance_of_this_badge_icon:
      "Ajustez l'apparence de cette icône de badge. Les modifications s’appliquent uniquement à ce badge.",
    badge_style: 'Style de badge',
    the_image_must_be_pixels: "L'image doit mesurer 200x200 pixels.",
    badge_name: 'Nom du badge',
    badge_descrription: 'Description du badge',
    enter_badge_criteria: 'Entrez les critères du badge',
    discard: 'Annuler',
    badge_enable: 'Badges activés',
    award_users_with_badges_to_highlight_the_milestones:
      'Attribuez des badges aux utilisateurs pour mettre en valeur les étapes de leur parcours d’apprentissage.',
    badge_types: 'Types de badges',
    enable_or_disable_specific_badge_types_for_your_users:
      'Activer ou désactiver des types de badges spécifiques pour vos utilisateurs.',
    levels_enabled: 'Niveaux activés',
    level_rules: 'Règles de niveau',
    points: 'Points',
    add_new_level: 'Ajouter un nouveau niveau',
    add_level: 'Ajouter un niveau',
    points_enabled: 'Points activés',
    learning_activities_and_encourage_healthy_competition:
      'Attribuez des points aux utilisateurs pour différentes activités d’apprentissage et encouragez une compétition saine.',
    award_points: 'Attribuer des points',
    the_following_equates_the_value_of_one_item_completion:
      "Ce qui suit équivaut à la valeur de l'achèvement d'un élément",
    general: 'Général',
    others: 'Autres',
    certificate: 'Certificat',
    quiz_passed: 'Quiz réussi',
    tip_approved: 'Astuce approuvée',
    tip_liked: 'Astuce aimée',
    rewards: 'Récompenses',
    offer_discounts_when_learners_achieve:
      'Offrir des réductions lorsque les apprenants atteignent un certain nombre de points, badges ou niveaux.',
    give_rewards: 'Offrir des récompenses',
    discount_course_purchases_by: 'Réduire les achats de cours de',
    with_points_more_than: 'avec plus de points que',
    with_badges_more_than: 'avec plus de badges que',
    with_level_upwards_more_than: 'avec un niveau supérieur à',
    leaderboard: 'Classement',
    leaderboard_enabled: 'Classement activé',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Les classements offrent aux utilisateurs un aperçu de leur progression en points par rapport aux autres.',
    show_levels: 'Afficher les niveaux',
    show_points: 'Afficher les points',
    show_badges: 'Afficher les badges',
    show_courses: 'Afficher les cours',
    show_certificates: 'Afficher les certificats',
    leaderboard_settings: 'Paramètres du classement',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Configurez des expériences de classement engageantes pour stimuler la motivation des apprenants.',
    award_users_with_points_for_different_learning_activities:
      'Attribuez des points aux utilisateurs pour différentes activités d’apprentissage.',
    badge_set: 'Ensemble de badges',
    choose_the_type_of_badges_your_users:
      'Choisissez le type de badges que vos utilisateurs gagneront en apprenant.',
    levels: 'Niveaux',
    Levels_represent_the_stages:
      "Les niveaux représentent les étapes du parcours d'apprentissage de l'utilisateur.",
    enabled: 'Activé',
    disabled: 'Désactivé',
    quick_select: 'Sélection rapide',
    yesterday: 'Hier',
    last_week: 'La semaine dernière',
    Last_month: 'Le mois dernier',
    last_quarter: 'Le trimestre dernier',
    historical_leaderboard: 'Classement historique',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Suivez vos performances et voyez comment vous vous situez parmi vos pairs',
    time_period: 'Période',
    page_of: 'Page 1 sur 1',
    edit_competition: 'Modifier la compétition',
    create_competition: 'Créer une compétition',
    arrow_right: 'flèche-droite',
    update_competition: 'Mettre à jour la compétition',
    competition_title: 'Titre de la compétition',
    enter_competition_title: 'Entrez le titre de la compétition',
    enter_competition_description: 'Entrez la description de la compétition',
    leaderboard_skill: 'Compétence',
    select_a_skill: 'Sélectionner une compétence',
    no_skills_found: 'Aucune compétence trouvée',
    competition_period: 'Période de la compétition',
    add_badge_rule: 'Ajouter une règle de badge',
    create_badge: 'Créer un badge',
    add_level_rule: 'Ajouter une règle de niveau',
    selected_participants: 'Participants sélectionnés',
    no_participants: 'Aucun participant',
    start_end_date: 'Date de début-fin',
    created_date: 'Créé par',
    new_competition: 'Nouvelle compétition',
    competitions_list: 'Liste des compétitions',
    search_competitions: 'Rechercher des compétitions...',
    are_you_sure_you_want_to_delete_the_competition:
      'Êtes-vous sûr de vouloir supprimer la compétition',
    history: 'Historique',
    export: 'Exporter',
    search_by_name: 'Rechercher par nom...',
    no_historical_data_available_for_the_selected_period:
      'Aucune donnée historique disponible pour la période sélectionnée.',
    no_leaderboard_data_available: 'Aucune donnée de classement disponible.',
    competitions: 'Compétitions',
    leaderboards: 'Classements',
    welcome_back: 'Bon retour',
    track_your_performance_and_see:
      'Suivez vos performances et voyez comment vous vous situez parmi vos pairs',
    team_leaderboard: "Classement d'équipe",
    try_again: 'Réessayer',
    no_competitions_for_search: 'Aucune compétition disponible pour',
    no_competitions_available: 'Aucune compétition disponible',
    no_competitions_matching_search:
      'Aucune compétition ne correspond à votre recherche. Essayez d’ajuster vos termes de recherche ou revenez plus tard pour de nouvelles compétitions.',
    no_competitions_general:
      'Aucune compétition n’est actuellement configurée. Revenez plus tard ou contactez votre administrateur pour créer de nouvelles compétitions.',
    media_management: 'Gestion des médias',
    badgess_set: 'Ensemble de badges',
    choose_the_default_visual_style_for_badge:
      'Choisissez le style visuel par défaut des icônes de badge utilisées sur la plateforme.',
    enable_badges: 'Activer les badges',
    add_badge: 'Ajouter un badge',
    min: 'Min',
    max: 'Max',
    your_rank: 'Votre rang',
    your_points: 'Vos points',
    your_level: 'Votre niveau',
    rank: 'Rang #',
    level: 'Niveau',
    progress: 'Progression',
    new_folder: 'Nouveau dossier',
    file_upload: 'Téléverser un fichier',
    writer: 'Écrivain',
    text_documents: 'Documents texte',
    spreadsheets: 'Tableurs',
    impress: 'Impress',
    presentations: 'Présentations',
    capture_desktop_screen: 'Capturer l’écran du bureau',
    capture_desktop_screens: 'Capturer les écrans du bureau',
    your_documents: 'Vos documents',
    manage_your_videos_images_audio_files:
      'Gérez vos vidéos, images, fichiers audio et autres ressources utilisées dans votre création de contenu.',
    your_organization_documents: 'Documents de votre organisation',
    keep_your_organization_creative_assets_organized:
      'Gardez les ressources créatives de votre organisation organisées et accessibles—optimisez le travail d’équipe et la production de contenu.',
    your_public_documents: 'Documents publics',
    curated_collection_of_media_assets_available:
      'Une collection de ressources médiatiques organisée et disponible pour tous—explorez, réutilisez et créez.',
    your_download_center_documents:
      'Documents de votre centre de téléchargement',
    repository_of_approved_media_assets_for_download:
      'Un référentiel de ressources médiatiques approuvées pour téléchargement et utilisation dans vos projets.',
    search_files_and_folders: 'Rechercher des fichiers et dossiers...',
    home: 'Accueil',
    folders: 'Dossiers',
    folder_name: 'Nom du dossier',
    owner: 'Propriétaire',
    last_updated: 'Dernière mise à jour',
    action: 'Action',
    no_folders_found: 'Aucun dossier trouvé',
    files: 'Fichiers',
    enabling_ai: 'Activation de l’IA...',
    rename: 'Renommer',
    copy: 'Copier',
    move: 'Déplacer',
    verson_history: 'Historique des versions',
    manage_permission: 'Gérer les permissions',
    generate_audit_report: 'Générer un rapport d’audit',
    last_edited: 'Dernière édition',
    no_files_found: 'Aucun fichier trouvé',
    are_you_sure_you_want_to_make_this_item_public:
      'Êtes-vous sûr de vouloir rendre cet élément public ? Il sera copié dans votre bibliothèque publique.',
    move_to_organization: 'Déplacer vers l’organisation',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Êtes-vous sûr de vouloir copier cet élément dans la bibliothèque de votre organisation ?',
    are_you_sure_you_want_to_make_this_item_private:
      'Êtes-vous sûr de vouloir rendre cet élément privé ? Il sera copié dans votre bibliothèque personnelle.',
    date_modified: 'Date de modification',
    workflow_management: 'Gestion des flux de travail',
    configure_editors_approvers_and_viewers_for_this_document:
      'Configurez les éditeurs, approbateurs et lecteurs pour ce document.',
    error_Loading_editor: "Erreur lors du chargement de l'éditeur",
    debug_info: 'Informations de débogage',
    loading_editor: 'Chargement de l’éditeur...',
    submitted_for_review: 'Soumis pour révision',
    editors: 'Éditeurs',
    no_editors_added_yet:
      'Aucun éditeur ajouté pour le moment. Cliquez sur "Ajouter un éditeur" pour en ajouter un.',
    add_editor: 'Ajouter un éditeur',
    approvers: 'Approbateurs',
    no_approvers_added_yet:
      'Aucun approbateur ajouté pour le moment. Cliquez sur "Ajouter un approbateur" pour en ajouter un.',
    add_approvers: 'Ajouter des approbateurs',
    viewer: 'Lecteur',
    no_viewers_added_yet:
      'Aucun lecteur ajouté pour le moment. Cliquez sur "Ajouter un lecteur" pour en ajouter un.',
    add_viewer: 'Ajouter un lecteur',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Êtes-vous sûr de vouloir supprimer les éléments sélectionnés ?'
  },
  v3: {
    reportShareSphere: 'SHARESPHERE',
    overview: 'Aperçu de la catégorie',
    triviaReport: 'ShareSphere Catégorie',
    overviewGraph: 'Graphique de l’aperçu de la catégorie',
    category: 'Catégorie',
    phCategory: 'Sélectionnez une catégorie',
    podcast: 'Podcasts, Musique et Histoires',
    pastPodcast: 'Podcast passé',
    upcomingPodcast: 'Podcast à venir',
    podcastLanguageTitle: 'Langue du podcast, musique et histoires',
    podcastLanguageCheckbox: 'Générer la langue de mon podcast avec l’IA',
    howRate: 'Comment évalueriez-vous ce podcast ?',
    podcastSubmit: 'Soumettre',
    podcastGuest: 'Invité :',
    podcastReview: 'Avis',
    podcastEpishode: 'Épisodes',
    podcastEnd: 'Le podcast est terminé',
    date_podcast: 'Date du podcast',
    skill_not_found: 'Désolé ! Aucun parcours de compétences trouvé.',
    coaching: 'Coaching',
    webinar: 'Webinaire',
    public_conference: 'Conférence publique',
    skill_journey_subtitle:
      'Ajoutez des paramètres à votre parcours de compétences et sélectionnez qui peut voir et interagir avec celui-ci.',
    enable_white_label: 'Activer le label blanc',
    create_new_event_org: 'Créer un nouvel événement pour votre organisation.',
    create_new_event_marketplace:
      'Créer un nouvel événement pour la marketplace.',
    create_new_event_both:
      'Créer un nouvel événement à la fois pour votre organisation et la marketplace.',
    event_outline: 'Veuillez saisir le plan de l’événement',
    event_obj: 'Veuillez saisir les objectifs de l’événement',
    event_description: 'Veuillez saisir la description de l’événement',
    create_new_metamaze_org:
      'Créer un nouveau MetaMaze pour votre organisation.',
    create_new_metamaze_marketplace:
      'Créer un nouveau MetaMaze pour la marketplace.',
    create_new_metamaze_both:
      'Créer un nouveau MetaMaze à la fois pour votre organisation et la marketplace.',
    add_key_words: 'Ajouter des mots-clés',
    press_enter_make_keyword: 'Appuyez sur Entrée pour créer un mot-clé',
    disable_skip_quiz: 'Désactiver le saut du quiz',
    warning_complete_quiz: 'Veuillez compléter le quiz pour continuer.',
    signup_email_verification:
      'Nous avons envoyé un lien de vérification à l’adresse que vous avez fournie. Veuillez visiter ce lien pour confirmer votre inscription.',
    verifying_registration: 'Vérification de l’inscription en cours...',
    reset_password_linK:
      'Nous avons envoyé un lien à l’adresse que vous avez fournie. Veuillez visiter ce lien pour définir un nouveau mot de passe.',
    reset_email_error:
      'Utilisateur non trouvé avec cet email, veuillez réessayer avec le nom d’utilisateur !',
    first_name: 'Prénom',
    last_name: 'Nom de famille',
    error_firstName: 'Veuillez saisir votre prénom',
    error_sharebot_organization: 'Veuillez saisir votre organisation',
    error_lastName: 'Veuillez saisir votre nom de famille',
    private_conference: 'Conférence privée',
    public_conference: 'Conférence publique',
    discussion_room: 'Salle de discussion',
    training_no_courses: 'Vous n’êtes actuellement inscrit à aucun cours.',
    training_no_events: 'Vous n’êtes actuellement inscrit à aucun événement.',
    allow_sharing_trainer_info:
      'Autoriser le partage de l’adresse email sur la marketplace',
    error_username_space: `Le nom d’utilisateur ne peut pas contenir d’espaces.`,
    error_sharebot_organization_space: `Le nom de l’organisation ne peut pas contenir d’espaces.`,
    edit_permission: 'Permission de modification',
    valid_price: 'Le prix doit être supérieur à 0',
    course_price_message: `*le cours sera publié uniquement pour le nombre d’utilisateurs achetés par l’organisation et ne pourra pas être revendu sur la marketplace`,
    valid_edit_price:
      'Le prix de modification doit être inférieur au prix d’achat.',
    my_calendar: 'Mon calendrier',
    error_valid_firstName: 'Veuillez entrer un prénom valide.',
    error_valid_organization: 'Veuillez entrer un nom d’organisation valide.',
    error_valid_lastName: 'Veuillez entrer un nom de famille valide.',
    error_name_spaces: `Le nom ne peut pas contenir d’espaces`,
    items: 'Articles',
    publish_to_channel: 'Publier dans ma chaîne',
    create_a_channel: 'Créer ma chaîne',
    create_a_trivia: 'Jeu Trivia',
    create_a_new_channel: 'Créer une nouvelle chaîne',
    add_videos: 'Ajouter des vidéos',
    save_and_continue: 'Enregistrer et continuer',
    channel: 'Chaîne',
    channels: 'Chaînes',
    view_channel: 'Voir la chaîne',
    edit_channel: 'Modifier la chaîne',
    delete_channel: 'Supprimer la chaîne',
    my_video_channels: 'Mes chaînes vidéo',
    training_no_channel: 'Vous n’êtes actuellement inscrit à aucune chaîne.',
    monthly_price_required: 'Le prix mensuel est requis',
    yearly_price_required: 'Le prix annuel est requis',
    one_time_price_required: 'Le prix unique est requis',
    marketplace_quantity: 'USD',
    report_webinar: 'WEBINAIRE',
    report_coaching: 'COACHING',
    report_channel: 'CHAÎNE',
    report_public_conference: 'CONFÉRENCE PUBLIQUE',
    report_maze: 'LABYRINTHE',
    channel: 'Chaîne',
    edit_price: 'Modifier le prix ($)',
    quantity: 'Quantité',
    payment_type: 'Type de paiement',
    total_amount: 'Montant total ($)',
    net_amount: 'Montant net ($)',
    edit_option: 'Option de modification',
    marketplace_price: 'Prix ($)',
    market_name: 'Nom',
    duration_min: 'Durée (min)',
    users_total: 'Utilisateurs (total)',
    sales_total: 'Total des ventes (USD)',
    search_coaching: 'Rechercher coaching',
    search_channel: 'Rechercher chaîne',
    search_webinar: 'Rechercher webinaire',
    search_maze: 'Rechercher labyrinthe',
    search_public_conference: 'Rechercher conférence publique',
    buyer_type: 'Type d’acheteur',
    quanity: 'Quantité',
    channel_unit_amount: 'Montant net ($)',
    channel_updated_at: 'Date de mise à jour',
    month: 'Mois',
    year: 'Année',
    onetime: 'Paiement unique',
    marketplace: 'Marketplace',
    marketplace_price_per_month: 'Prix par mois',
    marketplace_price_per_year: 'Prix par an',
    marketplace_price_onetime: 'Prix unique',
    month_label: 'Mois',
    year_label: 'Année',
    one_time_label: 'Paiement unique',
    select_filter: 'Sélectionner un filtre',
    search_filter_placeholder: 'Entrez le mot à rechercher',
    no_result_found: 'Aucun résultat trouvé',
    ai_course_title: 'Titre du cours',
    ai_input_course_title: 'Veuillez saisir le titre du cours !',
    learning_objective_label: "Objectif d'apprentissage",
    learning_objective_message: "Veuillez saisir l'objectif d'apprentissage !",
    standard_question: "Y a-t-il une norme que l'apprenant doit suivre ?",
    standard_details_label: 'Détails de la norme',
    standard_details_message: 'Veuillez saisir les détails de la norme !',
    estimated_duration_label: 'Durée estimée du cours (en minutes)',
    estimated_duration_message: 'Veuillez saisir la durée estimée !',
    min_duration_message: 'La durée minimale est de 5 minutes.',
    ai_mins: '25 minutes',
    industry_specific_question: 'Est-ce spécifique à une industrie ?',
    industry_label: "Spécifiez l'industrie",
    industry_message: "Veuillez saisir l'industrie !",
    ai_course_creation: 'Création de cours IA',
    course_generated: 'Cours généré par Sharelook',
    ai: 'IA',
    ai_you: 'Vous',
    ai_prompt_ready:
      'Votre prompt est prêt. Vous pouvez maintenant générer la table des matières.',
    ai_unable_respond:
      "Désolé ! L'IA ne peut pas répondre à votre prompt. Veuillez réessayer.",
    ai_hide_toc: 'Masquer la table des matières',
    ai_preview_toc: 'Aperçu de la table des matières',
    ai_generate_toc_now: 'Générer la table des matières maintenant',
    ai_creation_course_title: 'Titre du cours :',
    ai_creation_industry_specific: 'Est-ce spécifique à une industrie :',
    ai_creation_industry: 'Industrie :',
    ai_creation_standard_needed:
      "Y a-t-il une norme que l'apprenant doit suivre ? :",
    ai_creation_standard_details: 'Détails de la norme :',
    ai_creation_estimated_duration: 'Durée estimée du cours (en minutes) :',
    minutes: 'minutes',
    ai_creation_learning_objective: "Objectif d'apprentissage :",
    setup_again: 'Configurer à nouveau',
    ai_creation_confirm_title:
      'Êtes-vous sûr de vouloir reconfigurer le formulaire ?',
    ai_creation_confirm_content:
      'Le chat et tout le contenu généré seront réinitialisés.',
    ai_toc: 'Table des matières',
    ai_note_topic:
      'Note : Vous pouvez glisser-déposer pour réorganiser les sujets dans la leçon.',
    ai_add_topic: '+ Ajouter un sujet',
    add_topic: 'Ajouter un sujet',
    add_lesson: 'Ajouter une leçon',
    add_new_lesson: 'Ajouter une nouvelle leçon',
    ai_add_lesson: '+ Ajouter une leçon',
    attention: 'Attention',
    before_varifying: 'Avant la vérification',
    ai_save_later: 'Sauvegarder pour plus tard',
    ai_download_word_doc: 'Télécharger en document Word',
    ai_download_course_word_doc: 'Télécharger le cours en document Word',
    ai_create_course_button: 'Créer un cours',
    ai_generate_course_content: 'Générer le contenu du cours',
    ai_out_of: 'sur',
    ai_subtopic_failed_content:
      'les sous-sujets n\'ont pas pu générer de contenu. Cliquez sur "Générer le contenu du cours" à nouveau pour générer uniquement pour ces sous-sujets.',
    ai_edit_topic: 'Modifier le sujet',
    ai_edit_lesson_title: 'Modifier le titre de la leçon',
    ai_save_topic: 'Enregistrer le sujet',
    ai_save: 'Enregistrer',
    ai_save_lesson_title: 'Enregistrer le titre de la leçon',
    ai_add_new_topic: 'Ajouter un nouveau sujet',
    ai_download_ref: 'Télécharger avec références',
    ai_download_ref_content:
      'Cela téléchargera le cours en document Word avec références.',
    ai_download_without_ref: 'Télécharger sans références',
    ai_download_two_word: 'Deux documents Word seront téléchargés :',
    ai_download_two_word_content_one:
      '- un contenant le contenu principal sans références,',
    ai_download_two_word_content_two:
      "et l'autre contenant uniquement la liste des références sans contenu associé.",
    ai_manage_content: 'Gérer le contenu',
    ai_add_content_from_internet: '+ Ajouter du contenu depuis Internet',
    ai_confirm_start: 'Confirmer le démarrage',
    ai_Verify: 'Vérifier',
    ai_undo_warning:
      "Ce processus peut prendre du temps. Veuillez ne pas fermer cette fenêtre jusqu'à la fin de la génération car cela ne peut pas être annulé.",
    ai_verified_content:
      "Vous avez vérifié le contenu. Notez qu'après confirmation, vous ne pourrez plus revenir au chat avec l'assistant IA avec le contenu actuel.",
    ai_want_proceed: 'Êtes-vous sûr de vouloir continuer ?',
    upload_simulation: 'Télécharger une simulation',
    name_simulation: 'Nom de la simulation',
    selected_simulation_files: 'Fichiers de simulation sélectionnés',
    score_between_one_hundred: 'Votre score doit être compris entre 1 et 100.',
    are_sure_simulation:
      'Êtes-vous sûr de vouloir supprimer ce fichier de simulation ?',
    required_simulation: 'Le score est requis',
    required_section_file: 'Le fichier de section est requis',
    simulation: 'Simulation',
    simulation_quiz_games: "Besoin d'ajouter un quiz dans les jeux",
    simulation_alert_des:
      'Vous pouvez ajouter des jeux uniquement si toutes les questions ont un type de réponse unique ou multiple.',
    alert_info: 'info',
    ai_number_quiz: 'Nombre de quiz',
    ai_point: 'Point',
    ai_points: 'Points',
    val_required: 'Requis',
    games: 'Jeux',
    add_simulation: 'Ajouter une simulation',
    text_tiewer: 'Visionneuse de texte',
    back_to_account: 'Retour au compte',
    delete_account: 'Supprimer le compte',
    delete_account_title: 'Supprimer le compte ???',
    delete_account_subtitle: 'Vous pouvez supprimer votre compte ici.',
    delete_account_cannot_undo:
      'Vous êtes sur le point de supprimer votre compte. Cette action est irréversible.',
    account_org_profile:
      'Vous perdrez également tous les cours que vous avez créés, le profil de votre organisation et tous vos paramètres.',
    deleting_account_database:
      'La suppression de votre compte supprimera toutes vos données de notre base de données.',
    account_confirm_delete: 'Êtes-vous sûr de vouloir supprimer votre compte ?',
    action_cannot_be_undone: 'Cette action est irréversible.',
    account_delete_message_success: 'Votre compte a été supprimé avec succès.',
    message_edit: 'Modifier',
    message_delete: 'Supprimer',
    message_reply: 'Répondre',
    attached_file: 'Fichier joint',
    attach_file: 'Joindre un fichier',
    attach_des: '25 Mo, taille maximale du fichier',
    view: 'Voir',
    go_to_marketplace: 'Aller au Marketplace',
    learning_center: "Centre d'apprentissage",
    knowledge_center: 'Centre de connaissances',
    sharebot: 'ShareBot',
    sharebot_help_message: "Comment puis-je vous aider aujourd'hui ?",
    my_organization: 'Mon organisation',
    world_knowledge: 'Connaissances mondiales',
    welcome_to_sharelook: 'Bienvenue sur Sharelook !',
    sharelook_you_want_go: "Où voulez-vous aller aujourd'hui ?",
    shareLook_learning_management_system:
      "Accédez au système de gestion de l'apprentissage ShareLook pour créer ou accéder aux ressources pédagogiques telles que les événements en direct et les cours dans votre organisation sur ShareLook.",
    shareLook_powerful_ai_system:
      'Accédez au puissant système IA de ShareLook où vous pouvez télécharger des documents pdf et obtenir des informations utiles en quelques secondes. Obtenez des réponses rapides basées sur les ressources téléchargées dans votre organisation ou des réponses de notre système IA générique dans la section connaissances mondiales.',
    edit_now: 'Modifier maintenant',
    sharelook_log_out:
      'Vous avez été déconnecté de Sharelook. Veuillez vous connecter !',
    sorry_error: 'Désolé ! Nous avons rencontré une erreur.',
    login: 'Connexion',
    refresh_page: 'Actualiser la page',
    just_a_moment: 'Un instant',
    enter_lname_fname: 'Veuillez saisir votre prénom et nom pour continuer.',
    procced_to_sharelook: 'Aller à Sharelook',
    option_one: 'Option 1',
    option_two: 'Option 2',
    selected_image: 'Image sélectionnée :',
    add_text: 'Ajouter du texte',
    linkdin_is_required: 'LinkedIn est requis.',
    bio_is_required: 'La bio est requise.',
    save_user_information: 'Enregistrer les informations utilisateur',
    select_all: 'Tout sélectionner',
    enable_ai: "Activer l'IA",
    load_more: 'Charger plus',
    channel_id: 'ID de la chaîne.',
    send: 'Envoyer',
    v4: 'Informations',
    subscription: 'Abonnement',
    reset_user_flag: 'RÉINITIALISER LE STATUT UTILISATEUR',
    delete_my_accont: 'Supprimer mon compte',
    sharebot_sub_error:
      'Erreur lors de la récupération des abonnements. Réessayez !',
    sharebot_no_sub: "Vous n'avez actuellement aucun abonnement actif.",
    sharebot_dont_sub: "Vous n'avez aucun abonnement précédent.",
    sharebot_prev_sub: 'Abonnements précédents',
    sharebot_sub: 'Abonnement ShareBot',
    sharebot_un_sub: 'Désabonnement ShareBot',
    sharebot_no_available: 'Aucune description disponible',
    sharebot_start_date: 'Date de début :',
    sharebot_end_date: 'Date de fin :',
    sharebot_sure: 'Êtes-vous sûr ?',
    sharebot_do_you_want: 'Voulez-vous',
    unsubscribe: 'vous désabonner',
    unsubscribe_what: 'vous désabonner ?',
    subscribe: 'vous abonner',
    subscribe_what: 'vous abonner ?',
    subscribe_now: "S'abonner maintenant",
    confirm: 'Confirmer',
    sharebot_intel_knowledge_center:
      'Centre de connaissances intelligent de ShareBot',
    sharebot_welcome_paragraph:
      "Bienvenue au Centre de connaissances de ShareBot, le chatbot IA avancé conçu pour transformer la façon dont les professionnels accèdent à l'information et collaborent.",
    expired: 'Expiré',
    active: 'Actif',
    Inactive: 'Inactif',
    yearly_subscription: 'Abonnement annuel',
    monthly_subscription: 'Abonnement mensuel',
    no_sharebot_org: "Vous n'avez pas d'organisation ShareBot",
    sharebot_start_free_trial: "Commencer l'essai gratuit",
    sub_month: 'Abonnement mensuel',
    sub_year: 'Abonnement annuel',
    question_per_month: 'Stockage (1 To) et 1000 questions à vie',
    sharebot_para:
      "En continuant, vous confirmez vouloir supprimer définitivement l'organisation. Cette action supprimera toutes les ressources précieuses fournies par ShareBot et ne peut pas être annulée.",
    cancelled_date: 'Date d’annulation :',
    live_straming_para:
      'Pour modifier la limite de diffusion en direct mensuelle, veuillez contacter',
    sharelook_agree: "J'accepte les",
    terms_condition: "Conditions d'utilisation de Sharelook",
    and: 'et',
    privacy_policy: 'Politique de confidentialité',
    save_for_later: 'Enregistrer pour plus tard',
    ai: 'IA',
    no_video_yet: 'Aucune vidéo sélectionnée !',
    are_you_sure_delete_video:
      'Êtes-vous sûr de vouloir supprimer cette vidéo ?',
    video_des: 'Description',
    video_now: 'Maintenant',
    video_playing: 'Lecture en cours :',
    video_no: 'Vidéo n°',
    ai_generated_course: 'Cours généré par IA',
    create_course_on_our_own: 'Créer un cours manuellement',
    ai_Assisted_ourse_reation: 'Création assistée par IA',
    pending: 'En attente',
    published: 'Publié',
    intro_course: 'Ajouter à l’introduction du cours ?',
    clone_course: 'Souhaitez-vous cloner ce cours ?',
    browser_audio_not_support:
      "Votre navigateur ne prend pas en charge l'élément audio.",
    audio_popup_content:
      'Vous pouvez ajouter plusieurs fichiers audio selon votre texte — Lorem Ipsum est un texte standard utilisé depuis les années 1500.',
    close: 'Fermer',
    podcast_rec: 'ENREGISTREMENT',
    create_podcast: 'Créer un podcast',
    add_admin: 'Ajouter un administrateur',
    delete_all: 'Tout supprimer',
    ai_podcast_audio: 'Audio IA du podcast',
    language: 'Langue',
    podcast_download_content:
      "*Vous pouvez télécharger l'audio de la traduction IA et l'éditer avec votre propre éditeur.",
    upload_audio: 'Téléverser un audio',
    browser_do_not_support_audio:
      "Votre navigateur ne prend pas en charge l'élément audio.",
    upload_cover: 'Téléverser une image de couverture',
    upload_ai_creator: 'Ajouter un créateur IA',
    required_cover_image: "L'image de couverture est requise !",
    room_required_name: 'Le nom du podcast est requis !',
    add_guest_list: 'Ajouter des invités !',
    podcast_add_participants: 'Ajouter des participants',
    topic_required: 'Au moins un sujet est requis',
    podcast_description: 'Description',
    podcast_date: 'Date',
    date: 'Date',
    podcast_time: 'Heure',
    podcast_to: 'à',
    podcast_all_day: 'Toute la journée',
    podcast_start_date_time: 'La date et l’heure de début sont requises !',
    podcast_id: 'ID',
    selected_user: 'Utilisateurs sélectionnés invités',
    see_more: 'Voir plus',
    see_less: 'Voir moins',
    no_review_yet: "Pas encore d'avis – soyez le premier !",
    request_to_speak: 'Accepter la demande de parole de cet utilisateur ?',
    kick_user: 'Souhaitez-vous retirer cet utilisateur ?',
    accept_request: 'Accepter la demande',
    kick: 'Retirer',
    started: 'Commencé',
    end: 'Terminé',
    join_now: 'Rejoindre maintenant',
    podcast_end: 'Le podcast est terminé',
    connecting: 'Connexion en cours...',
    knowledge_center_know_today: 'Que souhaitez-vous apprendre aujourd’hui ?',
    knowledge_center_question: 'Tapez votre question',
    knowledge_center_error: 'Désolé ! Une erreur est survenue.',
    knowledge_center_tooltrip:
      "Accédez aux ressources d'apprentissage de votre équipe et téléversez des fichiers PDF.",
    my_organization: 'Mon organisation',
    world_knowledge: 'Connaissances globales',
    open_file: 'Ouvrir le fichier',
    reference: 'Référence',
    are_you_cancel: 'Souhaitez-vous vraiment annuler ?',
    are_you_remove_media: 'Souhaitez-vous vraiment supprimer ce média ?',
    terms_agree: "J'accepte les conditions",
    ready: 'Prêt',
    send_email: 'Envoyer un e-mail',
    active_users: 'Utilisateurs actifs',
    sign_up_user: 'Utilisateurs inscrits',
    non_sign_up_user: 'Utilisateurs non inscrits',
    organisation: 'Organisation',
    usage_report: "Rapport d'utilisation",
    check_email: 'Vérifiez votre e-mail',
    delete_schedule: 'Supprimer le planning',
    are_you_sure_delete_schedule:
      'Souhaitez-vous vraiment supprimer ce planning ?',
    add_task: 'Ajouter une tâche',
    coaching_available: 'Disponible pour coaching',
    message_booking_coaching:
      'Cet horaire est déjà réservé pour une session de coaching.',
    task_day: 'Jour de tâche',
    created_task_day: 'Une tâche a déjà été créée pour aujourd’hui.',
    event_day: "Jour d'événement",
    has_booked_coaching:
      'Une session de coaching est déjà réservée pour cette journée.',
    active_day: 'Jour actif',
    selectable_time_slots:
      'Les créneaux disponibles peuvent être sélectionnés en cliquant sur un jour actif.',
    compare_last_month: 'Comparer au mois dernier',
    uploading_file: 'Téléversement du fichier en cours',
    attach_file_course: 'Fichier joint au cours',
    fetch_request: 'Récupération de votre requête',
    finilize_upload: 'Finalisation du téléversement',
    scorm_scanned:
      'Veuillez patienter... vérification du fichier SCORM en cours.',
    scan_status: 'État du scan :',
    scan_completed: 'Scan terminé. Le fichier est',
    scan_progress: 'Scan en cours...',
    check_scorm: 'Vérification du fichier SCORM...',
    file_check_success: 'Vérification réussie',
    file_check_progress: 'Vérification du fichier en cours',
    scorm_not_upload:
      "Le fichier envoyé n'est pas compatible avec SCORM 1.2. Veuillez en téléverser un autre.",
    select_question: 'Question à choix (une seule bonne réponse)',
    select_answer: 'Veuillez sélectionner une réponse !',
    check_option_one: 'Veuillez entrer une option !',
    check_option_two: 'Veuillez entrer deux options !',
    check_option_three: 'Veuillez entrer trois options !',
    check_option_four: 'Veuillez entrer quatre options !',
    question_image: 'Image de la question',
    select_question_image: 'Sélectionnez une image pour la question !',
    ans_image: 'Image de réponse',
    upload_image_question: 'Téléverser une image de question',
    select_image_answer: 'Sélectionnez une image pour la réponse !',
    save_question: 'Enregistrer la question',
    do_you_leave: 'Souhaitez-vous quitter ? Êtes-vous sûr ?',
    loose_all_progress: 'Tout votre progrès sera perdu.',
    welcome: 'Bienvenue',
    team_knowledge_quest: "Quête de connaissances de l'équipe",
    your_score: 'Votre score',
    start_playing: 'Commencer à jouer',
    share_sphere_complete: 'ShareSphere terminé',
    final_score: 'Score final',
    play_next: 'Jouer le suivant',
    you_donot_access_event: "Vous n'avez pas accès à cet événement",
    ai_content_generated: 'Contenu généré par IA pour ce sujet',
    ai_popup_confirm_content: 'Confirmer la génération du contenu',
    limit_transcribe_text:
      'Minutes restantes pour la transcription : <0>{{ transcribe_limit }}</0> minutes <1/><2/> <3>. Pour modifier votre limite de transcription, veuillez contacter </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: "Vous n'avez pas accès à cet événement.",
    ai_course_title_training: 'Cours de formation en leadership',
    ai_course_object: 'Naviguer le leadership à l’ère numérique',
    create_ai_video: 'Créer une vidéo IA',
    generate: 'GÉNÉRER',
    video_generate_process:
      'Le processus de génération de la vidéo peut prendre un certain temps. Vous recevrez un e-mail une fois terminé.',
    stripe_account_connect:
      'Votre compte Stripe est inactif. Veuillez le connecter ou l’activer pour continuer.',
    ai_creator: 'Créateur IA',
    check_video_status:
      'Vérification du statut de la génération de la vidéo...',
    video_on_queue: 'La génération de la vidéo est en file d’attente.',
    video_fail_generation:
      'Désolé, la génération de la vidéo a échoué. Veuillez réessayer.',
    video_currently_generated: 'Cette vidéo est en cours de génération.',
    checking_status: 'Vérification du statut',
    check_status: 'Vérifier le statut',
    browser_does_not_support_audio:
      'Votre navigateur ne supporte pas la balise audio',
    existing_edit_scenario:
      "Voulez-vous modifier le scénario existant ou en créer un nouveau ? Si vous en créez un nouveau, l'ancien scénario sera perdu.",
    generate_scenario: 'Générer un scénario',
    layout: 'Disposition',
    confirm_change: 'Confirmer le changement',
    generated_ai_creation_message:
      'Veuillez noter que seuls les éléments de texte générés par la création IA seront conservés. Tous les autres éléments seront supprimés de la page.',
    generate_story: 'Générer une histoire',
    save_original_content: 'Sauvegarder le contenu original :',
    story_added_specified_position:
      "La position de l'histoire dans la leçon. L'histoire sera ajoutée comme un bloc à la position spécifiée.",
    position_of_story: "Position de l'histoire",
    start_the_lesson: 'Début de la leçon',
    end_the_lesson: 'Fin de la leçon',
    add_story_pages: "Ajouter l'histoire aux pages",
    browser_does_not_support:
      "Votre navigateur ne supporte pas l'élément audio.",
    no_video_available: 'Aucune vidéo disponible.',
    no_podcast_available: 'Aucun podcast disponible.',
    no_item_baskets: 'Aucun article dans le panier.',
    ai_course_object: 'Naviguer le leadership à l’ère numérique'
  },
  v2: {
    n_data: 'Pas de données',
    change: 'Changer',
    remove: 'Supprimer',
    auto_background: 'Arrière-plan automatique',
    create_new_course_org: 'Créer un nouveau cours pour votre organisation.',
    create_new_course_marketplace:
      'Créer un nouveau cours pour la place de marché.',
    create_new_course_both:
      'Créer un nouveau cours pour votre organisation et la place de marché.',
    ok: 'Ok',
    page_bg: 'Arrière-plan de la page',
    lesson_cover: 'Image de couverture de la leçon',
    create_skill_journey: 'Créer un parcours de compétences',
    Metamaze: 'Metamaze',
    events: 'Événements',
    scroms: 'SCORMs',
    min_score_pass: 'Score minimum pour réussir',
    no_scorms_available: 'Aucun SCORM disponible.',
    no_events_available: 'Aucun événement disponible.',
    no_courses_available: 'Aucun cours disponible.',
    no_courses_baskets: 'Aucun cours dans le panier.',
    no_mazes_baskets: 'Aucun labyrinthe dans le panier.',
    no_scroms_baskets: 'Aucun SCORM dans le panier.',
    no_events_baskets: 'Aucun événement dans le panier.',
    sorry: 'Désolé !',
    option_1: 'Option 1',
    option_2: 'Option 2',
    enter_number_words: 'Entrez le nombre maximal de mots.',
    summarize: 'Résumer',
    answer: 'Réponse',
    hold_tight_one_minute:
      'Un instant ! Nous préparons encore. Cela peut prendre jusqu’à une minute.',
    enter_question: 'Entrez votre question.',
    enter_relevant_documents: 'Entrez le nombre de documents pertinents.',
    please_input_relevant_documents:
      'Veuillez saisir le nombre de documents pertinents !',
    please_wait_loading_results:
      'Veuillez patienter pendant le chargement des résultats...',
    proceed_to_add_voice: 'Procéder à l’ajout de la voix',
    results: 'Résultats',
    no_result_found_try_asking_questions:
      'Aucun résultat trouvé. Essayez de poser plus de questions.',
    eg: 'ex. :',
    what_make_sales_manager:
      'Qu’est-ce qui peut faire de moi un responsable des ventes ?',
    please_select_lang: 'Veuillez sélectionner une langue !',
    search: 'Recherche',
    please_copy_desired_content:
      'Veuillez copier le contenu souhaité de la boîte de gauche vers celle de droite.',
    rating_req: 'La note est requise.',
    review_req: 'L’avis est requis.',
    rating_review_req: 'Vous devez fournir à la fois une note et un avis.',
    how_rate_this: 'Comment évalueriez-vous ceci ?',
    amazing_above_expectations: 'Incroyable ! Au-delà des attentes !',
    certificates: 'Certificats',
    you_no_certificates:
      'Vous n’avez aucun certificat disponible pour le moment.',
    please_add_review: 'Veuillez fournir un avis avec votre note. Merci !',
    post: 'Publier',
    rate: 'Évaluer',
    avg_rating: 'Note moyenne',
    no_review_found: 'Aucun avis trouvé',
    are_sure_to_disale_zoom_integration:
      'Êtes-vous sûr de vouloir désactiver l’intégration Zoom ?',
    badges: 'Badges',
    you_no_badge_available:
      'Vous n’avez aucun badge disponible pour le moment.',
    download_certificate: 'Télécharger le certificat',
    loading: 'Chargement...',
    no_file_attached: 'Aucun fichier joint',
    you_do_not_have_any_notes: 'Vous n’avez aucune note.',
    question: 'Question',
    score: 'Score',
    alert_score_message: 'Des personnes ont soumis leurs scores.',
    alert_question_message: 'Aucune question ajoutée pour le moment.',
    button_submit: 'Soumettre',
    button_allScores: 'Tous les scores ont été soumis.',
    record_wait: 'Enregistrement en cours. Veuillez patienter...',
    buttonSubmit_warning: 'Veuillez saisir tous les scores avant de soumettre.',
    upload_ar_assets: 'Téléverser des ressources RA',
    edit_ar_assets: 'Modifier les ressources RA',
    edit_maze_assets: 'Modifier les ressources MetaMaze',
    upload_assets: 'Téléverser des ressources',
    upload_maze_assets: 'Téléverser des ressources MetaMaze',
    trigger_title: 'Titre du déclencheur',
    model_title: 'Titre du modèle',
    trigger_description: 'Description du déclencheur',
    model_description: 'Description du modèle',
    please_type_target_description:
      'Veuillez saisir la description de la cible.',
    please_type_model_description: 'Veuillez saisir la description du modèle.',
    trigger_image: 'Image du déclencheur*',
    model_image: 'Image du modèle*',
    upload_trigger_image: 'Téléverser l’image du déclencheur',
    upload_model_image: 'Téléverser l’image du modèle',
    drag_n_drop: 'Glisser-déposer',
    file_size_should_not_exceed:
      '(La taille du fichier image (JPEG) ne doit pas dépasser 512 Ko)',
    zip_size_should_not_exceed:
      '(La taille du fichier zip ne doit pas dépasser 60 Mo)',
    ar_content: 'Contenu RA*',
    model_content: 'Modèle 3D*',
    upload_3d_zip: 'Téléverser ZIP / vidéo',
    upload_3d_maze_zip: 'Téléverser ZIP',
    audio_content: 'Contenu audio',
    _mp3: '(.mp3)',
    content_attached: 'Zip joint.',
    video_attached: 'Vidéo jointe.',
    audio_attached: 'Audio joint.',
    enter_trigger_image_title: 'Entrez le titre de l’image déclencheur.',
    enter_model_title: 'Entrez le titre du modèle MetaMaze.',
    ar_preview_image: 'Image d’aperçu RA',
    upload_preview_image: 'Téléverser l’image d’aperçu',
    upload_audio: 'Téléverser l’audio',
    creating___: 'Création…',
    updating___: 'Mise à jour…',
    create: 'Créer',
    update: 'Mettre à jour',
    ar_assets: 'Image 3D',
    _3d_files_mp4: '(ZIP .obj, .fbx ou vidéo .mp4)',
    _3d_files_mp4_ar: '(ZIP .obj, .fbx)',
    maze_3d_files_mp4: '(ZIP .obj, .fbx)',
    _jpg_files: 'Uniquement .jpg',
    persons_have_submitted_their_scores:
      'Les personnes ont soumis leurs scores.',
    no_questions_added_till_now: 'Aucune question ajoutée jusqu’à présent.',
    submit: 'Soumettre',
    all_scores_submitted: 'Tous les scores ont été soumis.',
    recording_is_starting: 'L’enregistrement commence. Veuillez patienter…',
    please_input_scores_before_submitting:
      'Veuillez saisir tous les scores avant de soumettre.',
    end_for_all: 'Terminer pour tous',
    full_screen: 'Plein écran',
    breakout_room: 'Salle de sous‑groupe',
    send_invitations: 'Envoyer les invitations',
    add_participants: 'Ajouter des participant·e·s',
    create_breakout_room: 'Créer la salle de sous‑groupe',
    connecting: 'Connexion en cours…',
    currently_broadcaster_unavailable:
      'Actuellement, l’orateur n’est pas disponible.',
    how_many_breakout_room_to_create:
      'Combien de salles de sous‑groupe créer ?',
    create_upto_three_breakout_rooms: '*Créer jusqu’à 3 salles de sous‑groupe',
    allow: 'Autoriser',
    additional: 'Supplémentaire',
    attachment: 'Pièce jointe',
    no_description_available: 'Aucune description disponible.',
    people: 'Personnes',
    waiting: 'En attente',
    hand_raising_users: 'Utilisateurs ayant levé la main',
    invite: 'Inviter',
    create_room: 'Créer la salle',
    create_live_event: 'Créer un événement en direct',
    support_upto_fivethousand_participants:
      'Prend en charge jusqu’à 5 000 participant·e·s',
    support_upto_ten_participants:
      'Prend en charge jusqu’à 10 participant·e·s vidéo',
    support_upto_twohundred_participants:
      'Prend en charge jusqu’à 200 participant·e·s pour l’événement',
    supprt_upto_five_participants:
      'Prend en charge jusqu’à 5 participant·e·s vidéo',
    support_upto_twentyfive_participants:
      'Prend en charge jusqu’à 25 participant·e·s vidéo',
    two_live_video_participants:
      '2 participant·e·s vidéo en direct (hôte et invité)',
    you_can_have_upto_five_examinees:
      'Vous pouvez avoir jusqu’à 5 examiné·e·s.',
    you_can_have_upto_twentyfive_participants:
      'Vous pouvez avoir jusqu’à 25 participant·e·s.',
    you_can_have_upto_five_participants:
      'Vous pouvez avoir jusqu’à 5 participant·e·s.',
    you_can_have_upto_ten_participants:
      'Vous pouvez avoir jusqu’à 10 participant·e·s.',
    select_hosts_email: 'Sélectionnez l’email de l’hôte',
    send_invite_email: 'Envoyer l’email d’invitation',
    do_not_send_invite_email: 'Ne pas envoyer l’email',
    error: 'Erreur',
    max_twentyfive_users_allowed: 'Max. 25 utilisateur·rice·s autorisé·e·s',
    max_five_users_allowed: 'Max. 5 utilisateur·rice·s autorisé·e·s',
    max_ten_users_allowed: 'Max. 10 utilisateur·rice·s autorisé·e·s',
    no_user_found: 'Aucun utilisateur trouvé',
    transcribe_to: 'Transcrire vers',
    integrate_zoom_to_start_meeting: 'Intégrez Zoom pour démarrer une réunion.',
    zoom_is_not_integrated: 'Zoom n’est pas intégré.',
    delete_poll: 'Supprimer le sondage',
    add_poll: 'Ajouter un sondage',
    live_now: 'EN DIRECT !',
    average_rating: 'Note moyenne',
    review: 'Commentaire',
    time_spent: 'Temps passé',
    total: 'Total',
    mins: 'Min',
    no_data: 'Aucune donnée disponible.',
    total_score: 'Score total',
    pass_score: 'Score de passage',
    point: 'Point',
    wrong: 'Faux',
    response: 'Réponse',
    submitted: 'Soumis',
    average: 'Moyenne',
    total_play: 'Total des parties',
    view_graph: 'Voir le graphique',
    time_spent_mins: 'Temps passé (min)',
    play: 'Jouer',
    ideal_path: 'Chemin idéal',
    user_incorrect_path: 'Chemin incorrect de l’utilisateur',
    ideal_path_taken: 'Chemin idéal emprunté par l’utilisateur',
    scenario: 'Scénario',
    option: 'Option',
    spend: 'Dépense',
    average_spending_time: 'Temps moyen dépensé',
    activity_overview: 'Aperçu de l’activité',
    live_event: 'Événement en direct',
    live_assessment: 'Évaluation en direct',
    report_download: 'Télécharger le rapport',
    all_workshops: 'Ateliers',
    overview_average_activity: 'Aperçu moyen de l’activité',
    overview_workshop_graph: 'Graphique de l’atelier',
    mazes: 'Labyrinthes',
    correct_feedback: 'Retour correct',
    incorrect_feedback: 'Retour incorrect',
    checkin_checkout: 'Enregistrement – Sortie',
    minutes: 'Minutes',
    incorrect_path: 'Chemin incorrect',
    answer_not_available: 'Réponse non disponible',
    views: 'Vues',
    item: 'Article',
    questions: 'Questions',
    total_points: 'Points totaux',
    total_attempts: 'Total des tentatives',
    created_date: 'Date de création',
    host_name: 'Nom de l’hôte',
    host_section: 'Section de l’hôte',
    choose_products: 'Choisir des produits',
    add_to_basket: 'Ajouter au panier',
    basket: 'Panier',
    times: 'Fois',
    scorms: 'SCORMs',
    skill_journey_overview: 'Aperçu du parcours de compétence',
    how_to_use: 'Comment utiliser',
    live_broadcast_description:
      'NOUS AVONS INTÉGRÉ LA DIFFUSION EN DIRECT À UN CRÉATEUR DE COURS FACILE D’UTILISATION',
    live_broadcast_subdescription:
      'Grâce au système de diffusion en direct breveté de ShareLook, vous pouvez créer de l’engagement, automatiser l’apprentissage et maximiser le partage de connaissances.',
    disclaimer: `J’atteste que mon parcours de compétences ne :
- viole pas les droits d’un tiers
- ne contient aucun contenu illégal (diffamatoire, indécent, violent, discriminatoire)
- n’inclut aucune attaque personnelle
- n’usurpe pas l’identité d’autrui
- n’enregistre aucune donnée personnelle sans consentement
- ne contient aucune sollicitation commerciale ou spam`,
    price: 'Prix',
    video_link: 'Lien vidéo',
    category: 'Catégorie',
    objectives: 'Objectifs',
    marketplace_description: 'Description du marché',
    live_discussion: 'DISCUSSION EN DIRECT',
    poll: 'Sondage',
    hide_grid: 'Masquer la grille',
    show_grid: 'Afficher la grille',
    stop_screen_share: 'Arrêter le partage d’écran',
    screen_share: 'Partager l’écran',
    mute: 'Muet',
    unmute: 'Réactiver le son',
    raise_hand: 'Lever la main',
    waiting__: 'En attente…',
    audio_active: 'Audio actif'
  },
  general: {
    save: 'enregistrer',
    autosaved: 'Enregistré automatiquement',
    back_to: 'Retour à',
    by: 'Par',
    chat: 'Bavarder',
    completed: 'Terminé',
    canceled: 'Annulé',
    component: 'Composante',
    confirm: 'Confirmer',
    course: 'Cours',
    skill: 'Parcours de Compétences',
    maze: 'MetaLabyrinthe',
    channel: 'Chaîne',
    podcast: 'Podcast',

    date: 'Date',
    details: 'Détails',
    empty: ' Aucune donnée',
    enrolled: ' Inscrit',
    free: 'Gratuit',
    graph: 'Graphique',
    loading: 'Chargement...',
    lesson: 'leçon',
    lessons: 'leçons',
    live_assessment: 'Evaluation en direct',
    live_event: ' Evénement en direct',
    no: 'Non',
    of: 'de',
    or: 'ou',
    organization: 'Organisation',
    page: 'Page',
    pages: 'Pages',
    personal: 'Personnel',
    poll: 'Sondage',
    rating: 'évaluation',
    reset: 'Réinitialiser',
    signin: 'Se connecter',
    signup: `S'inscrire`,
    soon: 'Bientôt',
    type: 'Type',
    uploading: 'Chargement...',
    yes: 'Oui',
    something_went_wrong: 'Quelque chose a mal tourné !',
    view_all: 'Tout afficher',
    upload_successful: 'Télécharger avec succès',
    upload_successful_message:
      'Vos documents excel ont été téléchargés avec succès et sont en cours de traitement. Cela peut prendre un certain temps',
    check_email_upload_successful:
      'Veuillez <0>vérifier votre email</0> pour le <1>rapport</1> de la liste des utilisateurs téléchargés',
    is_private: 'Privé'
  },

  account: {
    title: 'Compte',
    subtitle:
      'Gérer vos paramètres et les informations relatives à votre compte',
    saved: 'Compte modifié avec succès'
  },

  assessments: {
    title: 'Évaluations',
    subtitle: 'Créer une évaluation',
    finished: `L'évaluation est terminée`,
    countdown: `L'évaluation en direct sera diffusée en`,
    create: 'Créer une évaluation',
    list_title: `Vos évaluations`,
    delete_warning: `Etes-vous sûr de vouloir supprimer ce point ?`,
    details_title: `Ajouter les détails de l'évaluation`,
    details_subtitle: `Nommez votre évaluation et dites à votre public ce qu'il doit s'attendre à en tirer`,
    disclaimer: `Je garantis que mon évaluation enregistrée ne le sera pas :
    - ne portera pas atteinte aux droits d'un tiers
  - contenir toute illégalité, y compris un contenu diffamatoire, obscène, indécent, obscène, pornographique, violent, abusif, insultant, menaçant ou discriminatoire, même déguisé par des astérisques
  - contenir toute attaque personnelle contre d'autres personnes
  - contenir toute usurpation d'identité d'autres participants, de personnalités publiques ou de célébrités
  - contiennent un enregistrement ou des informations personnelles sur un individu sans le consentement de cet individu et ne violent aucune réglementation en matière de protection des données dans aucune partie du monde
  - contenir toute sollicitation commerciale ou toute forme de "spam".`,
    assessment_details: 'Détails de l’évaluation',
    assessment_settings: 'Paramètres d”évaluation'
  },
  buildersettings: {
    title: 'Publier les paramètres',
    subtitle:
      'Ajouter des paramètres à votre événement, qui peut voir et interagir avec votre événement'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Ajouter',
    add_page: 'Ajouter une page.',
    add_lesson: 'Ajouter des leçons',
    add_answer: 'Ajouter une nouvelle réponse',
    add_group: 'Ajouter un groupe',
    add_organization: 'Ajouter une organisation',
    add_question: 'Ajouter une question',
    add_quiz: 'Ajouter un quiz',
    add_users: 'Ajouter des utilisateurs',
    back: 'Retour',
    back_to_course: `Retour à l'aperçu des cours`,
    back_to_lesson: `Retour à l'aperçu des leçons`,
    back_to_media: `Retour à la médiathèque`,
    back_to_details: 'Retour aux détails',
    cancel: 'Annuler',
    clear: 'Effacer',
    close: ' Fermer',
    clone: 'Clone',
    close_lesson: 'Fermer la leçon',
    clone_course: 'Cours de clonage',
    confirm: 'Confirmer',
    create: ' Créer',
    download: 'Télécharger',
    download_mass_user_tamplate: 'Télécharger le modèle',
    add_mass_users: 'Ajouter des utilisateurs en masse',
    upload_excel_list: 'Téléchargez la liste Excel',
    delete: 'Supprimer les médias',
    edit: 'Modifier',
    edit_course: 'Modifier le Cours',
    enroll: 'Inscrivez-vous',
    finish: 'Finir',
    upload_image: `Téléchargez l'image`,
    upload_image_video: 'Téléchargez une image ou une vidéo',
    select_media_library: 'Sélectionnez la médiathèque',
    make_public: 'Rendre public',
    make_private: 'Rendre privé',
    make_org: `Faire de l'organisation`,
    media: 'Médiathèque',
    my_theme: 'Mon thème',
    next: 'Suivant',
    next_lesson: 'Leçon suivante',
    next_step: 'Prochaine étape',
    previous_step: 'Étape précédente',
    publish: 'Publier',
    publish_assessment: 'Publiez votre évaluation',
    publish_course: 'Publiez votre cours',
    publish_event: 'Publiez votre événement',
    reset: 'Réinitialisation',
    reset_elements: 'Réinitialisation des éléments',
    save: 'Enregistrer',
    creating: 'Créer...',
    updating: 'Mise à jour...',
    saved: 'Enregistré',
    save_for_later: 'Enregistrer pour plus tard',
    save_settings: 'Enregistrer les paramètres',
    select_files: 'Sélectionner les fichiers',
    select_theme: 'Sélectionnez un thème',
    start_lesson: 'Commencer une leçon',
    update: 'Mise à jour',
    upload: 'Télécharger',
    upload_audio: `Téléchargez l'audio`,
    upload_photo: 'Téléchargez une photo de profil',
    upload_video: 'Téléchargez la vidéo',
    enrolled: 'Inscrit',
    unenroll: 'Désinscription',
    from_library: 'Médiathèque',
    remove: 'Supprimer',
    removed: 'Supprimée',
    start_broadcast: 'Démarrer la diffusion',
    end_broadcast: 'Fin de la diffusion',
    camera: 'Caméra',
    screen: 'Écran',
    screen_with_camera: 'Écran avec caméra',
    insert: 'Insérer',
    inserting: 'Insertion'
  },
  card: {
    quick_add: 'Ajout rapide',
    add: 'Ajouter',
    clone: 'Clonage',
    completed: 'leçons achevées.'
  },
  course: {
    upcoming_course: 'Cours à venir',
    unPublishEvent: 'Événement non publié',
    unPublishAssessment: 'Évaluation non publiée',
    pastCourse: 'Cours de formation',
    upcoming: 'Prochain événement en direct',
    pastEvent: 'Evénements passés en direct',
    pastAssessment: 'Évaluation de la vie passée',
    upcomingAssessment: 'Évaluation en direct à venir',
    created: 'Date de création :',
    assignees: 'cessionnaires',
    organisations:
      '{{{ organisations }} organisations, <2> {{{{{utilisateurs}} utilisateurs</2>',
    event_date: `Date de l'événement en direct <1> {{ date }} </1>`,
    delete_warning: 'Etes-vous sûr de vouloir supprimer ?',
    clonning_no_lesson:
      'Veuillez ajouter au moins une leçon afin de cloner ce cours',
    clone_warning: 'Vous êtes sûr de vouloir cloner ceci ?',
    clone_success: 'est en cours de clonage',
    disclaimer: `Je garantis que mon cours ne le fait pas :
    - ne porte pas atteinte aux droits d'un tiers
    - contenir toute illégalité, y compris un contenu diffamatoire, obscène, indécent, obscène, pornographique, violent, abusif, insultant, menaçant ou discriminatoire, même déguisé par des astérisques
    - contenir toute attaque personnelle contre d'autres personnes
    - contenir toute usurpation d'identité d'autres participants, de personnalités publiques ou de célébrités
    - ne contiennent aucune information personnelle sur un individu sans le consentement de celui-ci et ne violent aucune réglementation sur la protection des données dans aucune partie du monde
    - contenir toute sollicitation commerciale ou toute forme de "spam".`
  },

  coursecreate: {
    dropzone_text: 'Insérer un média',
    sidebar_text: `Sélectionnez un thème <1/> pour vos cours <3/>`,
    delete_warning: `Etes-vous sûr de vouloir supprimer cette leçon ?`
  },
  coursepage: {
    quizview_loading: 'Vérification des réponses. Veuillez patienter...',
    quizview_answer: 'Votre réponse'
  },
  coursequiz: {
    title: 'Des quizz dans tous les cours'
  },

  dashboard: {
    tooltip_title: 'Ne plus montrer cette vidéo',
    page_title: 'Statistiques Vos cours',
    page_subtitle: 'Statut des cours que vous avez créés',
    profile_add_info: `Ajoutez votre <1>{{{texte non complété}}</1> pour compléter votre profil`,
    profile_build: `Construisez votre profil <1>ici</1>, faites-nous part de vos intérêts et de vos compétences`,
    profile_title: 'Force du profil',
    more_details: 'Plus de détails'
  },

  errors: {
    answer: 'Veuillez saisir votre réponse',
    answer_correct: 'Choisissez la bonne réponse',
    code: 'Veuillez entrer votre code',
    criterion: 'Veuillez saisir le critère',
    duration: 'La durée est obligatoire',
    element: `Veuillez saisir l'élément`,
    email: 'Veuillez saisir votre adresse électronique',
    email_invalid: `Ce n'est pas un courriel valide`,
    feedback_correct: 'Veuillez saisir les informations correctement',
    feedback_incorrect: 'Veuillez saisir un commentaire incorrect',
    host: `Veuillez indiquer le nom de l'organisateur de l'événement`,
    host_assessment: `Veuillez indiquer l'hôte de l'évaluation`,
    image: 'Veuillez télécharger une image',
    location: 'Veuillez indiquer votre localisation',
    live_location: 'Veuillez choisir un lieu de diffusion',
    limit: 'Veuillez saisir les minutes de retransmission en direct',
    min_3char: '3 caractères minimum',
    number: 'Veuillez saisir un nombre positif',
    host_email_require: `Les courriels de l'hôte sont obligatoires`,
    attendee_email_require: `Les courriels des participants sont obligatoires`,
    name: 'Veuillez saisir votre nom',
    not_found_course: 'Cours introuvable',
    not_found_event: 'Événement introuvable',
    not_found_assessment: 'Évaluation introuvable',
    password: 'Veuillez saisir votre mot de passe',
    password_digit: 'Au moins un chiffre',
    password_short: 'Le mot de passe est trop court, 10 caractères minimum',
    password_special: 'Au moins un caractère spécial',
    password_uppercase: 'Au moins un caractère majuscule',
    password_lowercase: 'Au moins un caractère minuscule',
    phone: 'Veuillez saisir votre numéro de téléphone',
    phone_invalid: 'Numéro de téléphone invalide',
    position: 'Veuillez indiquer votre position',
    question: 'Veuillez saisir la question',
    start_date: `La date et l'heure de début sont requises`,
    tag: 'Veuillez sélectionner une balise',
    topics: 'Veuillez sélectionner au moins un sujet',
    live_topics: 'Veuillez ajouter des sujets',
    title: 'Veuillez saisir le titre',
    title_assessment: `Veuillez saisir le titre de l'évaluation`,
    title_course: 'Veuillez saisir le titre du cours',
    title_empty: 'Le titre ne peut pas être vide',
    title_event: `Veuillez saisir le titre de l'événement`,
    title_lesson: `Veuillez saisir le titre de la leçon`,
    title_quiz: 'Veuillez saisir le nom du quiz',
    username: `Veuillez saisir votre nom d'utilisateur`,
    invalid_verification_code: `Ce lien de vérification a expiré ou n'est plus valide. Cela arrive généralement si un e-mail de vérification plus récent a été demandé. Veuillez vérifier le dernier e-mail reçu de la part de Sharelook pour confirmer votre adresse e-mail.`,
    upload_error: `Erreur - Fichier non compatible !`,
    upload_more_than_10:
      'Vous ne pouvez télécharger que 10 fichiers maximum à la fois',
    topics_max: 'Veuillez ajouter 3 sujets au maximum',
    upload_excel:
      'Veuillez vous assurer que vous avez téléchargé le bon fichier',
    title_excel: `Modèle de téléchargement d'erreur :`,
    file_size_exceed: 'La taille du fichier est supérieure',
    subtitle_excel:
      'Veuillez vous assurer que vous utilisez le modèle fourni et que les colonnes sont correctement remplies',

    select_broadcast_option:
      'Veuillez sélectionner une option pour la diffusion de cet événement',
    multi_hosts_number_error: `Le nombre de présentateurs ne peut pas dépasser celui qui est spécifié pour l'événement`,
    conference_people_number_error: `Le nombre de participants ne peut pas dépasser celui qui est spécifié pour l'événement`,
    select_max_host: `Sélectionnez au moins un présentateur pour l'événement`,
    select_max_conference: `Sélectionnez au moins un participant pour l'événement`,
    stream_stop_error: `Le streaming s'est arrêté de manière inattendue !`,
    unsecure_context: `Erreur fatale : Le navigateur ne peut pas accéder à la caméra et au micro en raison d'un contexte non sécurisé. Veuillez installer le SSL et l'accès via https`,
    ws_not_supported: `Erreur fatale : WebSocket n'est pas pris en charge par ce navigateur.`,
    no_org: 'Choisir au moins une organisation pour continuer.',
    no_org_group: 'Choisir au moins un groupe d’organisations pour continuer.',
    waiting_to_join: `En attendant que quelqu'un se joigne!`
  },

  events: {
    title: `Ajouter les détails d'un événement en direct`,
    change_host: `Changer d'hôte`,
    finished: `L'événement est terminé`,
    countdown: `L'événement sera retransmis en direct`,
    subtitle: `Nommez votre événement Live et dites à votre public ce qu'il doit en attendre`,
    poll_disabled: `Le sondage n'est pas disponible dans ce cas`,
    disclaimer: `Je garantis que mon événement enregistré ne le sera pas :
      - porter atteinte aux droits de tout tiers
    - contenir toute illégalité, y compris un contenu diffamatoire, obscène, indécent, obscène, pornographique, violent, abusif, insultant, menaçant ou discriminatoire, même déguisé par des astérisques
    - contenir toute attaque personnelle contre d'autres personnes
    - contenir toute usurpation d'identité d'autres participants, de personnalités publiques ou de célébrités
    - contiennent un enregistrement ou des informations personnelles sur un individu sans le consentement de cet individu et ne violent aucune réglementation en matière de protection des données dans aucune partie du monde
    - contiennent toute sollicitation commerciale ou toute forme de "spam"`,
    prompt_message:
      'En quittant cette page, vous terminez votre événement. Etes-vous sûr de quitter cette page ?',
    duration_exceed_message: `Votre temps de diffusion dépasse, l'application va cesser de diffuser`,
    before_schedule_message: `Vous êtes sur le point de commencer la diffusion avant l'heure prévue de l'événement. Veuillez noter que l'arrêt de la diffusion mettra fin à l'événement`,
    browser_unsupportive_message: `Votre navigateur ne prend pas en charge le partage d'écran. Vous pouvez voir les navigateurs pris en charge dans ce lien`,
    cancel_switch_host_message: `L'hôte n'est pas disponible. L'événement sera poursuivi de votre côté`,
    coaching_prompt_message: `Vous ne pouvez pas quitter cette page tant que l'événement n'est pas terminé`,
    event_modal_warn: `Voulez-vous quitter cet événement ?`,
    confirm_message: `Votre événement se terminera si vous cliquez sur OK`,
    screen_share_denied: 'Vous avez refusé de partager votre écran',
    media_not_found: `L'appareil photo ou le micro ne sont pas trouvés ou ne sont pas autorisés dans votre appareil`,
    media_not_access:
      'La caméra ou le micro est utilisé par un autre procédé qui ne permet pas de lire les appareils',
    constraint_error: `Il n'y a pas de dispositif trouvé qui corresponde à vos contraintes vidéo et audio. Vous pouvez modifier les contraintes vidéo et audio`,
    media_access_denied: `Vous n'êtes pas autorisé à accéder à la caméra et au micro.`
  },

  filters: {
    days7: 'Les 7 derniers jours',
    days15: 'Les 15 derniers jours',
    days30: 'Les 30 derniers jours',
    days365: 'Les 365 derniers jours',
    date: ' Date de création',
    relevance: 'Pertinence',
    popularity: 'Popularité',
    name: 'Nom',
    group: 'Groupe',
    Newest_to_Oldest: 'Du plus récent au plus ancien',
    Oldest_to_Newest: 'Du plus ancien au plus récent',
    A_Z: 'De A à Z',
    Z_A: 'De Z à A'
  },

  helpers: {
    password: `Pour garantir la sécurité de votre compte, nous vous demandons d'entrer au moins un numéro en minuscules dans votre mot de passe. Vous devez également avoir une longueur minimale de 10 caractères`,
    phone: `Veuillez indiquer l'indicatif de votre pays, par exemple : +65`,
    username: `Votre nom d'utilisateur est traité comme une information publique et partagé avec d'autres utilisateurs selon les besoins. Nous vous recommandons donc de ne pas utiliser d'informations personnelles dans votre nom d'utilisateur`,
    public_description_normal: `Votre <0><0/></0> a été enregistré et est considéré comme privé par défaut. Cela signifie que vous seul pouvez voir ce contenu. Pour publier ce contenu, vous pouvez sélectionner l'une des options ci-dessous. Publier votre cours en Public signifie qu'il sera disponible pour tous les utilisateurs de la plate-forme. L'option Utilisateurs spécifiques vous permettra de partager votre cours avec des utilisateurs spécifiques en utilisant l'adresse électronique associée à leur compte Sharelook`,

    public_description_admin: `Ce <0><0/></0> a été enregistré et est considéré comme privé par défaut. Cela signifie que seul vous (et le créateur du contenu) pouvez voir ce contenu . Pour publier ce contenu, vous pouvez sélectionner l'une des options ci-dessous. Publier votre cours au public signifie qu'il sera disponible pour tous les utilisateurs de la plate-forme - y compris ceux qui ne font pas partie de votre organisation. La publication au sein de l'organisation signifie que tous les utilisateurs au sein de l'organisation pourront le voir. Vous pouvez également le publier pour un ou plusieurs groupes, ce qui signifie que seuls les utilisateurs de ces groupes pourront le voir.  Enfin, vous avez la possibilité de le publier à des utilisateurs spécifiques au sein et en dehors de votre organisation en utilisant l'adresse électronique de leur compte Sharelook.`
  },

  labels: {
    add: 'Ajouter',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Type de réponse',
    answers: 'Réponses',
    back_to_quiz: 'Retour à la liste des quiz',
    back_to_question: 'Retour à la liste des questions',
    chat: 'Chat',
    chat_available: `Le chat n'est pas disponible dans ce cas`,
    chat_report: 'Rapport de chat',
    choice_single: 'Choix unique',
    choice_multiple: 'Choix multiple',
    choice_free: `Le "libre" choix`,
    choice_sorting: `Choix de "tri"`,
    choice_matrix: `Choix de "tri matriciel"`,
    clone_lesson_permission: 'Permission de cloner',
    code: 'Code',
    correct: 'Correct',
    created: 'Date de création',
    clone_modal: 'Cours de clonage',
    cloning_course: 'Cours de clonage...',
    cloning: 'Clonage...',
    cloning_course_desc: `Ce processus prendra un certain temps. Soyez patients`,
    cloning_success: `Le cours "<0/>" a été cloné avec succès !`,
    description: 'Description',
    disclaimer: 'Clause de non-responsabilité',
    drop_file: 'Déposez le fichier ici...',
    duration: 'Durée',
    edit: 'Modifier',
    email: 'Email',
    event: 'Evènement',
    event_all: 'Tous ses événements',
    event_date: 'Événement en direct, date/heure locale',
    event_this: 'Cet événement',
    expire: 'Expire le',
    expiry_date: `Date d'expiration`,
    forgot: `Mot de passe oublié`,
    group: 'Groupe',
    groups_list: 'Liste de Groupes',
    host: 'Hôte',
    id_annotation: 'ID de l’annotation',
    id_quiz: ' id du Quiz',
    incorrect: 'Incorrect',
    interests: 'Intérêts',
    invited: 'Invité',
    live_chat: 'Discussion en direct',
    live_stream_limit: 'diffusion en direct',
    contact_text: `Pour modifier votre limite mensuelle de diffusion en direct, veuillez contacter`,
    contact_admin:
      '<0>Si vous souhaitez modifier votre limite mensuelle de diffusion en direct, veuillez contacter</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'Les minutes restantes de la diffusion en direct : <0>{{{limite }}</0> minutes <1/><2/> <3>Pour modifier votre limite mensuelle de diffusion en direct, veuillez contacter</3> <4>admin@sharelook.com</4>',
    location: 'Localisation',
    lessons: 'Lecons',
    location_broadcast: 'Emplacement du serveur hôte',
    location_broadcast_subtitle: `Ajouter un emplacement qui soit le plus proche de celui de l'hôte de la diffusion afin de réduire le retard audiovisuel`,
    media_manager: 'Responsable des médias',
    minutes: 'Minutes',
    name: 'Nom',
    online_quiz: 'Quiz en ligne',
    organiser: 'Auteur',
    organization: 'Organisation',
    overall_emotion: 'Expérience globale :',
    organizations_list: 'Liste des organisations',
    password: 'Mot de passe',
    participants: 'Participants',
    picture: 'image (16:9)',
    phone: 'Tél',
    photo: 'Photo',
    poll: 'Sondage',
    position: 'Poste',
    processing: 'Traitement',
    privacy_settings: 'Paramètres de confidentialité',
    question: 'Question',
    quiz_create: 'Créer un nouveau quiz',
    quiz_name: 'Nom du quiz',
    quiz_update: 'Mise à jour du quiz',
    select_organization: 'Sélectionnez une organisation',
    settings: 'Paramètres',
    show: 'Afficher',
    show_graph: 'Afficher le résultat du graphique',
    signin: 'Connexion',
    signup: 'Inscription',
    sort_by: 'Trier par',
    start_date: 'Date de début',
    tags: 'Balises',
    terms: `Je suis d'accord avec ces <1>modalités et conditions</1>`,
    title: 'Titre',
    topics: 'Sujets',
    topic: 'Sujet',
    total_comments: 'Total des commentaires',
    username: `Nom d'utilisateur`,
    users_list: 'Liste des utilisateurs',
    users_emails: `Insérer les courriels d'utilisateurs spécifiques`,
    description_specifiction_email:
      'Veuillez entrer une adresse électronique par ligne pour la partager avec plusieurs utilisateurs spécifiques',
    message_specific_email: `Veuillez saisir l'adresse électronique de l'utilisateur spécifié`,
    viewers: 'Spectateurs',
    edit_course: 'Modifier',
    edit_assessment: 'Modifier',
    edit_event: 'Modifier',
    delete_course: 'Effacer',
    delete_event: 'Effacer',
    delete_assessment: ' Effacer ',
    view_course: ' Voir',
    view_event: ' Voir ',
    view_assessment: ' Voir ',
    date_event: `Date de l'événement en direct`,
    date_assessment: `Date de l'évaluation en direct`,
    clone_of: ' Clone',
    clone_course: `Créez un clone de ce cours que vous pouvez modifier indépendamment de l'original et qui comprend toutes les leçons et les pages`,
    make: 'Faire',
    available_to: `disponible à tout utilisateur de ShareLook`,
    uploaded_by: 'Téléchargé par : ',
    course: 'Cours',
    assessment: ' Évaluation',
    user_not_exist: `L'utilisateur n'existe pas, vous voulez envoyer une invitation?`,
    check_user: 'Avis',
    user_not_exist_in_org: `L'utilisateur n'existe pas dans cette organisation, souhaitez-vous envoyer une invitation ?`,
    title_modal_stream: `Changer l'organisation de la limite du flux de vie`,
    des_warning_stream: 'Vous êtes sur le point de changer',
    monthly_stream: 'limite mensuelle de diffusion en direct :',
    min_per_month: 'Min/mois',
    broadcast_label: 'Je veux faire :',
    hosts_emails: `Insérer les e-mails d'un hôte spécifique`,
    attendee_emails: `Insérer les courriels d'un participant spécifique`,
    description_host_specifiction_email:
      'Veuillez entrer une adresse électronique par ligne',
    presenter_label: 'Présentateur',
    presenter_label_conference: 'Nombre de personnes',
    event_privacy: 'Mode conférence',
    alert: 'Alerte!',
    warning: 'Avertissement!',
    ok: `D'accord`,
    cancel: 'Annuler',
    done: 'Terminé',
    insert: 'Insérer',
    private: 'Privée',
    public: 'Publique',
    no_connection: 'Connexion Internet perdue',
    switch: 'Commutateur',
    share_screen: `Partager l'écran`,
    stop_share_screen: `Arrêter l'écran de partage`,
    share_screen_with_camera: `Partager l'écran avec la caméra`,
    stop_share_screen_with_camera: `Arrêter le partage d'écran avec la caméra`,
    camera_on: 'Caméra allumée',
    camera_off: 'Caméra désactivée',
    mic_on: 'réactiver',
    mic_off: 'muette',
    fullscreen: 'plein écran',
    live_now: 'Vis maintenant',
    schedule_on: 'Programmer pour',
    organisations: 'Organisations',
    org_groups: `Groupes d'organisation`,
    specific_user: 'Utilisateur spécifique',
    gif: 'GIF',
    unavailable: 'indisponible',
    yes: 'Oui',
    no: 'Non',
    event_duration_message: 'Max 300 minutes (5 heures)',
    send_email: 'Envoyer une notification par e-mail',
    admin_only: 'Admin seulement',
    join: 'Joindre',
    leave: 'Laisser'
  },

  broadcastOptions: {
    stream_from_phone: 'Diffusion en direct avec mon téléphone',
    other_webrtc: 'Webinaire depuis mon PC',
    multihost: 'Webinaire multidiffusion à partir de mon PC',
    peer2peer: 'Session de coaching',
    conference: 'Conférence en direct'
  },

  lessoncreate: {
    title: 'Ajoutez les détails de la leçon',
    subtitle: `Nommez votre leçon et dites à votre public ce qu'il doit s'attendre à en tirer`,
    input_label_title: 'Titre de la leçon',
    input_label_topics: 'Thèmes des leçons',
    input_label_description: 'Description de la leçon',
    delete_warning: `Etes-vous sûr de vouloir supprimer cette page ?`
  },

  lessonoverview: {
    title: 'Ajouter une leçon',
    subtitle: 'Ajouter une leçon existante ou en créer une nouvelle',
    new_lesson: 'créer une nouvelle leçon',
    new_lesson_sub: 'Créez une toute nouvelle leçon à partir de zéro !',
    existing_lesson: 'Sélectionnez une leçon existante',
    existing_lesson_sub: `Lien vers une leçon existante, les modifications apportées à cette leçon affecteront également cette leçon dans d'autres cours`,

    clone_lesson: 'dupliquer une leçon existante',
    clone_lesson_sub: `Faites une copie unique de la leçon dans ce cours, les modifications apportées à cette leçon n'affecteront pas la leçon originale`,
    clone_lesson_modal_sub: `Veuillez cliquer sur le bouton "clone" situé sous la leçon que vous souhaitez ajouter à votre cours.`
  },

  management: {
    groups_title: 'Gérer les groupes',
    delete_warning: 'Êtes-vous sûr ?',
    organizations_title: 'Mes Organisations',
    organizations_subtitle: 'Ajoutez des organisations à votre liste',
    users_title: 'Gérer les utilisateurs',
    users_position: 'Responsable de compte',
    user_not_found: 'Utilisateur introuvable',
    select_org:
      'Veuillez trouver et choisir une organisation pour gérer les utilisateurs'
  },

  audio: {
    modal_title: 'Insérer un Audio',
    list_view: 'Vue de la liste',
    create_audio_modal_title: 'Créez un fichier audio',
    edit_audio_modal_title: 'Editer un Audio',
    public_audio_not_found: 'Audio non trouvé',
    private_audio_not_found: `Vous n'avez pas encore téléchargé d'audio`,
    are_you_sure_to_delete: `Êtes-vous sûr de vouloir supprimer ?`,
    type_something: 'Tapez quelque chose',
    select_voice: 'Selectionner',
    file_name: 'Nom du fichier',
    description: 'Description',
    topic: 'Sujet',
    key_words_tag: 'Mot clé',
    mp3_audio: ' Audio MP3 ',
    created: ' Créé ',
    duration: 'Durée',
    close: 'Fermer'
  },

  image: {
    modal_title: 'Insérer une Image',
    image: 'Image',
    pixel: 'Pixel',
    dimension: 'Dimension',
    public_image_not_found: 'Image introuvable.',
    private_image_not_found: `Vous n'avez pas encore téléchargé d'image`
  },

  annotation: {
    modal_title: 'Annotation'
  },

  text: {
    modal_title: 'Éditeur de texte'
  },

  video: {
    modal_title: 'Insérer une Video',
    image: 'Vidéo',
    mp4_video: 'MP4 Vidéo',
    public_video_not_found: 'Vidéo introuvable.',
    private_video_not_found: `Vous n'avez pas encore téléchargé de vidéo`
  },

  media: {
    title: 'Médiathèque',
    subtitle: 'Bibliothèque de vos dossiers',
    modal_title: 'Téléchargez les médias',
    delete_warning: 'Confirmer la suppression',
    delete_message:
      'Les supports supprimés apparaîtront toujours sur les pages où ils ont été utilisés',
    dropzone_text: `ou "glisser-déposer"`,
    delete_success: 'Le média a été supprimé avec succès',
    upload_file: 'Téléchargez le fichier',
    drag_drop: 'ou "glisser-déposer"',
    import_file: 'Importer un ou plusieurs fichiers de votre ordinateur',
    no_media: `Vous n'avez encore téléchargé aucun média`,
    media_type: 'Type de média',
    video: 'Vidéo',
    image: 'Image',
    audio: 'Audio',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Médias introuvables',
    of: 'de',
    disclaimer: `Je garantis que mes médias ne le font pas :
    - n'enfreignent pas les droits d'un tiers
    - contenir toute illégalité, y compris un contenu diffamatoire, obscène, indécent, obscène, pornographique, violent, abusif, insultant, menaçant ou discriminatoire, même déguisé par des astérisques
    - contenir toute attaque personnelle contre d'autres personnes
    - contenir toute usurpation d'identité d'autres participants, de personnalités publiques ou de célébrités
    - ne contiennent aucune information personnelle sur un individu sans le consentement de celui-ci et ne violent aucune réglementation sur la protection des données dans aucune partie du monde
    - contenir toute sollicitation commerciale ou toute forme de "spam".`,
    my_media: 'Mes médias',
    public_library: 'Bibliothèque publique',
    organization_library: `Bibliothèque de l'organisation`,
    upload_from_computer: `Télécharger à partir de l'ordinateur`,
    create: 'Créer',
    all: 'Tous',
    male: 'Masculin',
    female: 'Feminin',
    processing_audio: `Traitement de l'audio`,
    create_annotation: 'Créer une annotation',
    popup_over_lesson_text: `L'annotation apparaîtra sur la page de la leçon après le clic`,
    edit_detail: 'Modifier le détail',
    delete: 'Supprimer',
    go_create_audio: `créer de l'audio`,
    show_more_details: 'montrer plus de détails',
    show_less_details: 'montrer moins de détails',
    drop_files: 'Déposer des fichiers et où les télécharger',
    or: 'Ou',
    import_files: 'Importer les fichiers à partir de l’ordinateur) '
  },

  navigation: {
    account: 'Compte',
    assessments: 'Évaluations',
    dashboard: 'Tableau de bord',
    groups: 'Gestion de groupe',
    logout: 'Déconnexion',
    organisations: 'Organisations',
    organizations_users: 'Organisations et utilisateurs',
    reports: 'Rapports',
    schedule: 'Programme',
    nowLive: 'Diffuser',
    training: 'Formation',
    users: 'Utilisateurs',
    workshop: 'Mon atelier'
  },

  onboarding: {
    step1_title: `Étape 1 : Parlez-nous un peu de vous`,
    step1_subtitle: `Quel est votre nom ? D'où venez-vous ? Quel est votre titre de fonction ?`,
    step2_title: `Étape 2 : Sélectionnez certaines compétences que vous pourriez améliorer`,

    step2_subtitle: `Ensuite, dites-nous ce que vous aimeriez mieux comprendre. Peut-être quelque chose que vous n'avez pas encore compris ? Un nouveau domaine d'étude ? Ce que fait votre proche ?`
  },

  pagebuilder: {
    title: 'Créer une leçon',
    subtitle: `Il est temps de créer le contenu pour que votre public apprenne de vous, vous pouvez faire des photos, des vidéos et des infographies`,
    select_layout: 'Sélectionnez une mise en page',
    template1: 'Vide',
    template2: 'Titre et sous-titre',
    template3: 'Titre et texte',
    template4: `Titre, médias et texte`,
    template5: 'Titre et médias',
    template6: 'Titre et quiz'
  },

  pageconstructor: {
    title: 'Créer et cloner une leçon',
    subtitle: `Il est temps de créer le contenu pour que votre public apprenne de vous, vous pouvez ajouter des photos, des vidéos et des infographies".`
  },

  passwordreset: {
    success_coded: `Nous avons envoyé par e-mail un code de confirmation à l'adresse que vous avez fournie, veuillez copier le code dans le champ ci-dessous pour définir un nouveau mot de passe`,
    success_changed: `Vous avez réussi à définir un nouveau mot de passe. Vous pouvez vous connecter maintenant.`
  },

  placeholders: {
    search: 'Recherche',
    answer: 'Réponse',
    chat: 'Dis quelque chose...',
    code: 'Code',
    criterion: 'Critère',
    date_event: `Sélectionnez la date et l'heure`,
    date_start: 'Date de début',
    date_expire: `Date d'expiration`,
    description: 'Description',
    elements: 'Trier les éléments',
    email: 'Email',
    feedback_correct: 'Feedback Correct',
    feedback_incorrect: 'Feedback Incorrect',
    host: 'Hôte',
    keywords: `Recherche de mot(s) clé(s)`,
    lesson_description: 'Description de la leçon',
    location: 'Localisation',
    minutes: 'Minutes',
    name: 'Nom',
    organiser: 'Auteur',
    organization: 'Organisation',
    password: `Mot de passe`,
    phone: 'Téléphone',
    photo: 'Photo',
    picture: 'image',
    point: 'Point',
    position: 'Poste',
    question: 'Question',
    quiz: 'Nom du quiz',
    search_course: `Recherche par cours`,
    search_media: `Recherche de médias`,
    search_name: 'Recherche par nom',
    search_title: 'Recherche par titre',
    search_training: 'Formation à la recherche',
    settings: 'Paramètres',
    tags: 'Balises',
    title: 'Titre',
    topics: 'Sujets',
    username: `Nom d'utilisateur`,
    keyword: 'Mots-clés',
    max_500_characters: 'Max 500 caractères',
    no_description: `Ce fichier n'a pas de description`,
    no_keyword: `Ce fichier n'a pas de mots-clés`,
    no_topics: `Ce fichier n'a pas de thème défini`,
    feedback: 'Message',
    contact: `Comment pouvons-nous vous aider ?`
  },

  publishsettings: {
    title: 'Publier les paramètres',
    event_subtitle: `Ajoutez des paramètres à votre événement, qui peut voir et interagir avec votre événement`,
    assessment_subtitile: `Nommez votre évaluation et dites à votre public ce qu'il doit en attendre`,
    course_subtitle: `Ajouter des paramètres à votre cours, qui peut voir et interagir avec votre cours`,
    disclaimer: `
     1.	Inscription

En vous inscrivant en tant qu'utilisateur/en créant un compte, vous acceptez nos [Conditions d'utilisation] et reconnaissez avoir lu notre [Politique de confidentialité].



2.	Créer un cours

En utilisant nos outils et en créant le contenu des cours, vous acceptez notre [Contrat d'utilisation] et reconnaissez avoir lu notre [Politique de confidentialité].



3.	Créer un événement

En utilisant nos outils et en créant un événement, vous acceptez nos [Conditions d'utilisation] et reconnaissez avoir lu notre [Politique de confidentialité].


4.	Créer une évaluation

En utilisant nos outils et en créant une évaluation, vous acceptez nos [Conditions d'utilisation] et reconnaissez avoir lu notre [Politique de confidentialité].`,

    dates_validation_error: 'Les deux dates doivent être remplies',
    course_dates_validation_error: 'Veuillez indiquer la date de début et d\'expiration de ce cours.',
    emails_validation_error: `La liste d'adresses électroniques n'est pas valable`,
    specific_email_validation_error: 'Un seul courriel est autorisé',
    i_agree_to_these: `Je suis d'accord avec celles-ci`,
    terms_and_conditions: 'conditions générales',
    PublicDescription: `Utilisateurs indépendants gratuits : (options privées et publiques)Votre [Cours|Événement|Évaluation] a été enregistré et est considéré comme privé par défaut. Cela signifie que vous seul pouvez voir ce contenu. Pour publier ce contenu, vous pouvez choisir de le rendre public ci-dessous. Cela signifie que le cours sera disponible pour tous les utilisateurs de la plate-forme`,
    OrganisationsDescription: `Utilisateurs de l'Org : (Au lieu de "Terminer", utilisez "Publier" et amenez-les à la page de publication comme les autres utilisateurs, mais sans aucune des options de publication. Cela signifie que seuls vous et les administrateurs de votre organisation pouvez le voir. En tant qu'utilisateur, vous ne pouvez pas publier vous-même votre contenu au sein de votre organisation car cela nécessite des droits d'administrateur. Veuillez contacter l'un de vos administrateurs et lui demander de publier votre contenu publiquement, à l'ensemble de l'organisation, à des groupes spécifiques au sein de votre organisation ou à des utilisateurs spécifiques`,

    OrganisationGroupsDescription: `Org Admins : (Pour les contenus réalisés au sein de l'organisation : Privé, public, organisation, groupes, utilisateurs spécifiques) : Ce [Cours|Événement|Évaluation] a été enregistré et est considéré comme privé par défaut. Cela signifie que seul vous (et le créateur du contenu) pouvez voir ce contenu . Pour publier ce contenu, vous pouvez sélectionner l'une des options ci-dessous. Publier votre cours au public signifie qu'il sera disponible pour tous les utilisateurs de la plate-forme, y compris ceux qui ne font pas partie de votre organisation. La publication au sein de l'organisation signifie que tous les utilisateurs au sein de l'organisation pourront le voir. Vous pouvez également le publier pour un ou plusieurs groupes, ce qui signifie que seuls les utilisateurs de ces groupes pourront le voir.  Enfin, vous avez la possibilité de le publier à des utilisateurs spécifiques au sein et en dehors de votre organisation en utilisant l'adresse électronique de leur compte Sharelook`,

    SpecificUsersDescription: `Utilisateurs indépendants rémunérés : (utilisateurs privés, publics et spécifiques)Votre [Cours|Événement|Évaluation] a été enregistré et est considéré comme privé par défaut. Cela signifie que vous seul pouvez voir ce contenu. Pour publier ce contenu, vous pouvez sélectionner l'une des options ci-dessous. Publier votre cours en public signifie qu'il sera disponible pour tous les utilisateurs de la plate-forme. L'option Utilisateurs spécifiques vous permettra de partager votre cours avec des utilisateurs spécifiques en utilisant l'adresse électronique associée à leur compte Sharelook.`
  },

  quiz: {
    quiz_empty: `Vous n'avez pas encore créé de quiz`,
    questions_empty: `Vous n'avez pas encore créé de question`
  },

  regions: {
    asia_pacific_australia: 'Australie',
    asia_pacific_india: 'Inde',
    asia_pacific_japan: 'Japon',
    asia_pacific_s_korea: ' Corée du Sud',
    asia_pacific_singapore: ' Singapour',
    asia_pacific_taiwan: 'Taiwan',
    eu_belgium: 'Belgique',
    eu_germany: 'Allemagne',
    eu_ireland: ' Irlande',
    south_america_brazil: 'Brésil',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: ' Caroline du Sud',
    us_east_virginia: 'Virginie',
    us_west_california: 'Californie',
    us_west_oregon: ' Oregon'
  },

  reports: {
    title: 'Rapports',
    workshop_report: `Rapport d'atelier`,
    user_report: `Rapport d'utilisateur`,
    organization_workshop: `Atelier d'organisation`,
    course: 'Cours',
    live_event: 'Evénement en direct',
    workShop_graph: `Graphique d'atelier`,
    organization_account: `Compte de l'organisation`,
    all: 'Tous',
    name: 'Nom',
    id_number: `Numéro d'identification`,
    email: 'Email',
    search_user_report: `Rapport de l'utilisateur de recherche`,
    participant: 'Participant',
    participants: 'Participants',
    host: 'Hôte',
    username: `Nom d'utilisateur`,
    event: 'Événement',
    quiz: 'Quiz',
    assessment: 'Évaluation',
    time: 'Heure',
    no_recent_activity: `Aucune activité récente`,
    workshops: 'Ateliers',
    courses: 'Cours',
    live_events: 'Événements en direct',
    live_assessments: 'Évaluations en direct',
    quizzes: 'Quizz',
    overview: `Vue d'ensemble`,
    by: 'Par',
    views: 'Vues',
    status: 'Statuts',
    poll: 'Sondage',
    comment: ' Commentaire',
    comments: 'Commentaires',
    no_comments: 'Aucun commentaire',
    no_polls: 'Pas de sondages',
    live_date: ' Date de diffusion',
    score: 'Score',
    question: 'Question',
    submit: 'Envoyer',
    recent_activity: ' Activité récente',
    ago: 'Il y a longtemps',
    no_data_found: 'Aucune donnée trouvée',
    start_end_live: 'Début / fin du direct',
    join_leave_date: 'Rejoindre / quitter',
    watched_time: 'Le temps regardé',
    complete: 'Terminer',
    in_complete: ' Entièrement',
    today: `Aujourd'hui`,
    seven_days: '7 Jours',
    last_month: 'Le mois dernier',
    one_year: '1 an',
    all_time: 'Tout le temps',
    report: 'Rapport',
    from_date: 'Date de début',
    to_date: 'à',
    all_workshop: 'Tous les ateliers',
    all_participants: 'Tous les Participants',
    live_assessment: 'Évaluation en direct',
    users: 'Utilisateurs',
    download: 'Télécharger',
    recent: 'Récent',
    WorkShop: 'Atelier',
    Activity: 'Activité',
    created_date: 'Date de création',
    lessons: 'Leçons',
    lesson: 'Leçon',
    completed: 'Terminé',

    report_download: 'Téléchargement de rapports',
    this_month: 'Ce mois-ci',
    search_course: 'rechercher un Cours',
    participants_graph: 'Graphique des participants',
    viewed: 'Vu',
    enrolled: 'Inscrit',
    description: 'Description',
    topic: 'Sujet',
    analytic: 'Analytique',
    quiz_list: 'Liste de quiz',
    select_one: 'Sélectionner un',
    group_status: 'Statut de groupe',
    duration_min: 'Durée (min)',
    submit_poll: 'Soumettre un sondage',
    download_events: 'Télécharger les événements',
    search_event: 'Rechercher un événement',
    duration: 'Durée',
    total_participants: 'Total des participants',
    message: 'Message',
    avg_message: 'Moyenne. Message',
    per_message: 'UN POURCENTAGE DE MESSAGES / ÉVÉNEMENT'
  },

  signup: {
    success_step1: `Nous avons envoyé par e-mail un code de vérification à l'adresse que vous avez fournie, veuillez copier le code dans le champ ci-dessous pour confirmer votre inscription`,
    success_step2: `Merci. Vous êtes enregistré avec succès`,
    privacy: `J'accepte les conditions générales <1> de Sharelook</1> et <3> de la politique de confidentialité</3>.`
  },

  stream: {
    emotion_impressive: 'Impressionnant',
    emotion_unimpressive: 'Peu impressionnant',
    message_not_started: 'A venir',
    message_running: 'En direct',
    message_processing: `Nous sommes en train de traiter l'enregistrement en direct pour la lecture. Veuillez revenir plus tard pour visionner la vidéo et continuer à ajouter des évaluations et des commentaires.`
  },

  tabs: {
    audience: 'Audience',
    course: ' Aperçu du cours',
    details: `Détails de l'événement en direct`,
    description: 'Description',
    host: ' Hôte :',
    lesson: ' Aperçu de la leçon',
    lessons: 'Leçons',
    overview: `Vue d'ensemble`,
    page: ' Créateur de pages',
    publish: 'Publier',
    settings: 'Publier les Paramètres',
    total_views: 'vues totales',
    live_participates: ' Participants en direct',
    live_chats: 'Chats en direct',
    live_quiz: 'Sondages en direct',
    trainer_rating: 'Évaluation des formateurs',
    trainer_times: ' Horaires des formateurs',
    courses_quizzes: ' Quiz sur les cours',
    user_list: ' Liste des utilisateurs',
    discussion: ' Discussion',
    notes: ' Mes notes'
  },

  topics: {
    SALES_TRAINING: ' Formation à la vente',
    NEGOTIATION_TRAINING: ' Formation à la négociation',
    CROSS_CULTURAL_AWARENESS: ' Sensibilisation interculturelle',
    NETWORKING_SKILLS: ' Compétences en matière de mise en réseau',
    SOFTWARE_ARCHITECTURE: ' Architecture logicielle',
    PROJECT_MANAGEMENT: ' Gestion de projet',
    DIGITAL_TRANSFORMATION: ' Transformation numérique',
    IT_CONSULTING: ' Conseil en informatique',
    MANAGEMENT_CONSULTING: ' Conseil en gestion',
    HR_CONSULTING: ' Conseil en ressources humaines',
    INTERNET_OF_THINGS: ' Internet des objets (IoT)',
    CYBERSECURITY: ' Cyber sécurité',
    PRIVACY_AND_GDRP: ' Vie privée et GDPR'
  },

  training: {
    title: ' Formation',
    title_assessment: ' Évaluations',
    subtitle: ' Cours et événements en direct',
    enrolled_title: ' Cours inscrits et événements en direct',
    enrolled_subtitle:
      ' Cours et événements en direct auxquels vous vous êtes inscrit',
    enrolled_message: `Vous n'êtes actuellement inscrit à aucun cours ou événement `,
    past_live_event_title: ' Événements passés en direct',
    past_live_event_subTitle: ' Événements en direct terminés',
    past_live_event: ` Il n'y a actuellement aucun événement passé en direct.`,
    recomended_title: ' Cours et événements en direct recommandés',
    now_live_event_title: ' Maintenant en direct',
    now_live_event_subTitle: ' Les événements en direct ou à venir',
    now_live_event: `Il n'y a actuellement aucun événement en direct.`,
    webinar_event_title: ' Canal webinaire',
    webinar_event_subTitle: ' Webinaires terminés',
    webinar_event: `Il n'y a pas de webinaire actuellement.`,
    p2p_event_title: `Séances d'entraînement`,
    p2p_event_subTitle: `Séance d'entraînement terminé`,
    p2p_event: `Il n'y a actuellement aucune session de coaching.`,
    now_live_assessment_title: ' Maintenant en direct',
    now_live_assessment_subTitle:
      'Les évaluations sont en cours ou le seront très bientôt',
    now_live_assessment_message: `Il n'y a actuellement aucune évaluation en direct`,
    upcoming_assessment_title: `Prochaines évaluations en direct`,
    upcoming_assessment_subtitle: 'Prochaines évaluations en direct',
    upcoming_assessment_message: `Il n'y a actuellement aucune évaluation en direct à venir`,

    past_live_assessment_title: ' Évaluations en direct antérieures',
    past_live_assessment_subTitle: 'Evaluation en direct terminé',
    past_live_assessment_message: `Il n'y a actuellement aucune évaluation en direct`,

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Nous avons organisé des cours et des événements en direct sur la base de vos <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Formation à la recherche',
    search_assessment: 'Évaluation de la recherche',
    recomended_message: `Il n'y a actuellement aucun cours ou événement recommandé.`
  },

  warnings: {
    delete: 'Vous êtes sûr ?'
  },

  workshop: {
    title: 'Mon atelier',
    subtitle: ' Créez un cours ou organisez votre propre événement en direct',
    new_course: 'Créer un nouveau cours',
    new_event: 'Créer un nouvel événement en direct',
    new_assessment: 'Créer une nouvelle évaluation en direct',
    courses_title: `Création de cours et d'événements en direct`,
    courses_subtitle: 'Edit & Publish your created course and plan live events',
    tags_course: 'Cours',
    tags_live: 'Événement en direct',
    tags_assessment: 'Évaluation en direct'
  },

  help_center: {
    sidebar: {
      title: 'Comment pouvons-nous vous aider ?',
      back_to: 'Tableau de bord'
    },
    menu: {
      help_center: `Centre d'aide`,
      whats_new: 'Quoi de neuf',
      feedback: 'Feedback',
      feedback_title: `Envoyez vos commentaires à sharelook`,
      terms_and_conditions: ' Conditions générales',
      privacy_policy: ' Politique de confidentialité',
      contact_us: 'Nous contacter'
    },
    get_started: {
      title: 'Commencez par partager votre regard',
      description: {
        main:
          'NOUS AVONS INTÉGRÉ LA VIDÉO EN DIRECT DANS UN GÉNÉRATEUR DE COURS FACILE À UTILISER',
        tagline: `Avec le système breveté de diffusion en direct de ShareLook, vous pouvez créer un engagement, automatiser l'apprentissage et maximiser le partage des connaissances.`
      }
    },
    whats_new: {
      title: 'Commencez par partager votre regard',

      description: {
        main: `Saviez-vous que l'apprentissage du style narratif peut se faire en peu de temps et à moindre coût ?  Vous devriez combiner le concepteur de cours ShareLook et les talents respectifs. Vous pouvez nous demander "COMMENT"`,
        tagline: ''
      }
    },
    create_workshop: 'Comment créer un atelier',
    create_course: 'Comment créer un cours',
    create_user: 'Comment créer un utilisateur',
    create_group: 'Comment créer un groupe',
    create_webinar: 'Comment créer un webinaire',
    create_live_event: 'Comment créer un événement en direct',
    create_live_assessment: 'Comment créer une évaluation en direct',
    create_live_on_mobile: 'Créer un direct sur le mobile',
    personalize_profile: 'Personnaliser un profil',
    manage_group: 'Gérer un groupe',
    report: 'Rapport',
    add_annotations: 'Comment ajouter des annotations et des popups',
    add_audio: `Comment ajouter de l'audio`,
    add_header_and_footer: `Ajout d'un en-tête et d'un pied de page`,
    add_image: 'Comment ajouter une image',
    add_quiz_content: 'Comment ajouter du contenu au quiz',
    add_text_content: 'Comment ajouter du contenu textuel',
    add_user: 'Comment ajouter un utiliateur',
    add_video: 'Comment ajouter une vidéo',
    clone_course: 'Comment cloner un cours',
    find_live_broadcast: 'Comment trouver une diffusion en direct',
    contact_us: {
      title: 'Nous contacter',
      subject_placeholder: 'Saisir un Objet*',
      content_placeholder: 'Saisir un message*',
      subject_required: '* Un objet est obligatoire ',
      content_required: '* Un message est obligatoire ',
      submit: 'Envoyer',
      cancel: 'Annuler',
      sent: 'Envoyé'
    },
    feedback: {
      title: 'Envoyer un feddback à sharelook',
      attach_title: 'Joindre un fichier',
      choose: 'Choisir un fichier',
      detail: `Le dossier sera partagé avec l'équipe de soutien`,
      content_placeholder: 'saisir un message*',
      content_required: '*Un message est obligatoire',
      submit: 'envoyer',
      cancel: 'Annuler',
      sent: 'envoyé'
    }
  },
  discussion: {
    join_discussion: 'rejoindre en discussion'
  },
  notes: {
    title: 'Mes Notes',
    add_note: 'Ajouter une nouvelle note'
  }
}
